/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ({

/***/ 0:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	var _WidgetRegistrySingleton = __webpack_require__(9);
	
	var _WidgetRegistrySingleton2 = _interopRequireDefault(_WidgetRegistrySingleton);
	
	var _LoggerSingleton = __webpack_require__(3);
	
	var _LoggerSingleton2 = _interopRequireDefault(_LoggerSingleton);
	
	var _loglevel = __webpack_require__(4);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	var _SchoolSearchSelect = __webpack_require__(76);
	
	var _SchoolSearchSelect2 = _interopRequireDefault(_SchoolSearchSelect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	// Set the default loglevel
	var logger = new _LoggerSingleton2.default();
	logger.setDefaultLogLevel(_loglevel2.default.INFO);
	
	// Get an instance of the widget registry
	var widgetRegistry = new _WidgetRegistrySingleton2.default();
	
	// Register the cradmin widgets we are using
	// widgetRegistry.registerWidgetClass('cradmin-menutoggle', MenuToggleWidget);
	// widgetRegistry.registerWidgetClass('cradmin-toggleable-menu', ToggleableMenuWidget);
	widgetRegistry.registerWidgetClass('school-search-select', _SchoolSearchSelect2.default);
	// Register the project specific widgets
	// widgetRegistry.registerWidgetClass('something', Something);
	
	
	// Initalize the widgets
	function _onDomReady() {
	  // Initialize all widgets in document.body
	  widgetRegistry.initializeAllWidgetsWithinElement(document.body);
	}
	
	if (document.readyState !== 'loading') {
	  _onDomReady();
	} else {
	  document.addEventListener('DOMContentLoaded', function () {
	    _onDomReady();
	  });
	}

/***/ }),

/***/ 2:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _ObjectManager = __webpack_require__(19);
	
	var _ObjectManager2 = _interopRequireDefault(_ObjectManager);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Base class for widgets for {@link WidgetRegistrySingleton}.
	 *
	 * @example <caption>Create a very simple widget</caption>
	 * export default class OpenMenuWidget extends AbstractWidget {
	 *     constructor(element, widgetInstanceId) {
	 *          super(element, widgetInstanceId);
	 *          this._onClickBound = (...args) => {
	 *              this._onClick(...args);
	 *          };
	 *          this.element.addEventListener('click', this._onClickBound);
	 *     }
	 *
	 *     _onClick = (e) => {
	 *          e.preventDefault();
	 *          console.log('I should have opened the menu here');
	 *     }
	 *
	 *     destroy() {
	 *          this.element.removeEventListener('click', this._onClickBound);
	 *     }
	 * }
	 *
	 * @example <caption>Use the widget</caption>
	 * <button type="button" data-ievv-jsbase-widget="open-menu-button">
	 *     Open menu
	 * </button>
	 *
	 * @example <caption>A widget with configuration input</caption>
	 * export default class OpenMenuWidget extends AbstractWidget {
	 *     constructor(element) {
	 *          super(element);
	 *          this._onClickBound = (...args) => {
	 *              this._onClick(...args);
	 *          };
	 *          this.element.addEventListener('click', this._onClickBound);
	 *     }
	 *
	 *     getDefaultConfig() {
	 *          return {
	 *              'menuId': 'id_main_menu'
	 *          }
	 *     }
	 *
	 *     _onClick = (e) => {
	 *          e.preventDefault();
	 *          console.log(`I should have opened the menu with id="${this.config.menuId}" here`);
	 *     }
	 *
	 *     destroy() {
	 *          this.element.removeEventListener('click', this._onClickBound);
	 *     }
	 * }
	 *
	 * @example <caption>Use the widget with config</caption>
	 * <!-- Using the default config -->
	 * <button type="button" data-ievv-jsbase-widget="open-menu-button">
	 *     Open the main menu
	 * </button>
	 * <!-- Override the menuId config -->
	 * <button type="button" data-ievv-jsbase-widget="open-menu-button"
	 *          data-ievv-jsbase-widget-config='{"menuId": "id_the_other_menu"}'>
	 *     Open the other menu
	 * </button>
	 */
	var AbstractWidget = function () {
	
	    /**
	     * @param {Element} element The element to load the widget in.
	     * @param {string} widgetInstanceId The unique ID of this widget instance
	     *  in the widget registry.
	     */
	    function AbstractWidget(element, widgetInstanceId) {
	        _classCallCheck(this, AbstractWidget);
	
	        this.element = element;
	        this.widgetInstanceId = widgetInstanceId;
	    }
	
	    /**
	     * Get the default config.
	     *
	     * Any config supplied via the ``data-ievv-jsbase-widget-config``
	     * attribute is merged into this object.
	     *
	     * @returns {Object}
	     */
	
	
	    _createClass(AbstractWidget, [{
	        key: 'getDefaultConfig',
	        value: function getDefaultConfig() {
	            return {};
	        }
	    }, {
	        key: '_parseConfig',
	        value: function _parseConfig() {
	            var attributeName = 'data-ievv-jsbase-widget-config';
	            if (this.element.hasAttribute(attributeName)) {
	                var rawConfig = this.element.getAttribute(attributeName);
	                var config = JSON.parse(rawConfig);
	                return config;
	            }
	            return {};
	        }
	
	        /**
	         * Get the config.
	         *
	         * JSON decodes any config supplied via the ``data-ievv-jsbase-widget-config``
	         * attribute of the Element and {@link AbstractWidget#getDefaultConfig}
	         * into a config object. The result of this is cached, so multiple calls
	         * to this property will only result in the config object being created
	         * once.
	         *
	         * @throws {SyntaxError} If the ``data-ievv-jsbase-widget-config`` attribute
	         *      does not contain valid JSON data.
	         *      Not thrown if the element does not have a
	         *      ``data-ievv-jsbase-widget-config`` attribute.
	         *
	         * @returns {Object} The config object. This will be an empty object
	         *      if we have no {@link AbstractWidget#getDefaultConfig} and
	         *      no config is supplied via the ``data-ievv-jsbase-widget-config``
	         *      attribute of the Element.
	         */
	
	    }, {
	        key: 'destroy',
	
	
	        /**
	         * Destroy the widget.
	         *
	         * You should override this in subclasses if your
	         * widget sets up something that will work incorrectly
	         * if the widget disappears or is re-created (such as event
	         * listeners and signals).
	         */
	        value: function destroy() {}
	
	        /**
	         * If you override {@link AbstractWidget#afterInitializeAllWidgets},
	         * you must override this to return ``true``.
	         *
	         * @returns {boolean} Should return ``true`` if you want the widget registry
	         *   to call {@link AbstractWidget#afterInitializeAllWidgets}.
	         */
	
	    }, {
	        key: 'useAfterInitializeAllWidgets',
	        value: function useAfterInitializeAllWidgets() {
	            return false;
	        }
	
	        /**
	         * Called after all the widgets within the element that
	         * {@link WidgetRegistrySingleton#initializeAllWidgetsWithinElement}
	         * was called with is initialized.
	         *
	         * For performance reasons, this is only called if
	         * {@link AbstractWidget#useAfterInitializeAllWidgets} returns
	         * ``true``, so you must also override that method if you override
	         * this method.
	         *
	         * This is useful if you need to do something after other
	         * widgets have finished initializing, which may be the case
	         * for loosely coupled widgets.
	         *
	         * Does nothing by default.
	         */
	
	    }, {
	        key: 'afterInitializeAllWidgets',
	        value: function afterInitializeAllWidgets() {}
	    }, {
	        key: 'config',
	        get: function get() {
	            if (typeof this._config === 'undefined') {
	                var parsedConfig = this._parseConfig();
	                this._config = _ObjectManager2.default.mergeAndClone(this.getDefaultConfig(), parsedConfig);
	            }
	            return this._config;
	        }
	    }]);
	
	    return AbstractWidget;
	}();
	
	exports.default = AbstractWidget;

/***/ }),

/***/ 3:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _Logger = __webpack_require__(18);
	
	var _Logger2 = _interopRequireDefault(_Logger);
	
	var _loglevel = __webpack_require__(4);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var _instance = null;
	
	/**
	 * A logging system.
	 *
	 * @example <caption>Create and use a logger</caption>
	 * import LoggerSingleton from 'ievv_jsbase/lib/log/LoggerSingleton';
	 * let mylogger = new LoggerSingleton().loggerSingleton.getLogger('myproject.MyClass');
	 * mylogger.debug('Hello debug world');
	 * mylogger.info('Hello info world');
	 * mylogger.warning('Hello warning world');
	 * mylogger.error('Hello error world');
	 *
	 * @example <caption>Set a default loglevel for all loggers</caption>
	 * import LOGLEVEL from 'ievv_jsbase/lib/log/loglevel';
	 * new LoggerSingleton().setDefaultLogLevel(LOGLEVEL.DEBUG);
	 *
	 * @example <caption>Set a custom loglevel for a single logger</caption>
	 * import LOGLEVEL from 'ievv_jsbase/lib/log/loglevel';
	 * new LoggerSingleton().getLogger('mylogger').setLogLevel(LOGLEVEL.DEBUG);
	 */
	
	var LoggerSingleton = function () {
	    /**
	     * Get an instance of the singleton.
	     *
	     * The first time this is called, we create a new instance.
	     * For all subsequent calls, we return the instance that was
	     * created on the first call.
	     */
	    function LoggerSingleton() {
	        _classCallCheck(this, LoggerSingleton);
	
	        if (!_instance) {
	            _instance = this;
	        }
	        this._loggerMap = new Map();
	        this.reset();
	        return _instance;
	    }
	
	    /**
	     * Get the number of loggers registered using
	     * {@link getLogger}.
	     *
	     * @returns {number} The number of loggers.
	     */
	
	
	    _createClass(LoggerSingleton, [{
	        key: "getLoggerCount",
	        value: function getLoggerCount() {
	            return this._loggerMap.size;
	        }
	
	        /**
	         * Reset to default log level, and clear all
	         * custom loggers.
	         */
	
	    }, {
	        key: "reset",
	        value: function reset() {
	            this._logLevel = _loglevel2.default.WARNING;
	            this._loggerMap.clear();
	        }
	
	        /**
	         * Get the default log level.
	         *
	         * Defaults to {@link LogLevels#WARNING} if not overridden
	         * with {@LoggerSingleton#setDefaultLogLevel}.
	         *
	         * @returns {int} One of the loglevels defined in {@link LogLevels}
	         */
	
	    }, {
	        key: "getDefaultLogLevel",
	        value: function getDefaultLogLevel() {
	            return this._logLevel;
	        }
	
	        /**
	         * Set the default loglevel.
	         *
	         * All loggers use this by default unless
	         * you override their loglevel.
	         *
	         * @example <caption>Override loglevel of a specific logger</caption>
	         * import LoggerSingleton from 'ievv_jsbase/log/LoggerSingleton';
	         * import LOGLEVEL from 'ievv_jsbase/log/loglevel';
	         * let loggerSingleton = new LoggerSingleton();
	         * loggerSingleton.getLogger('mylogger').setLogLevel(LOGLEVEL.DEBUG);
	         *
	         * @param logLevel The log level. Must be one of the loglevels
	         *      defined in {@link LogLevels}.
	         * @throws {RangeError} if {@link LogLevels#validateLogLevel} fails.
	         */
	
	    }, {
	        key: "setDefaultLogLevel",
	        value: function setDefaultLogLevel(logLevel) {
	            _loglevel2.default.validateLogLevel(logLevel);
	            this._logLevel = logLevel;
	        }
	
	        /**
	         * Get a logger.
	         *
	         * @param {string} name A name for the logger. Should be a unique name,
	         *      so typically the full import path of the class/function using
	         *      the logger.
	         * @returns {Logger}
	         */
	
	    }, {
	        key: "getLogger",
	        value: function getLogger(name) {
	            if (!this._loggerMap.has(name)) {
	                this._loggerMap.set(name, new _Logger2.default(name, this));
	            }
	            return this._loggerMap.get(name);
	        }
	
	        /**
	         * Get the names of all the registered loggers.
	         *
	         * @returns {Array} Sorted array with the same of the loggers.
	         */
	
	    }, {
	        key: "getLoggerNameArray",
	        value: function getLoggerNameArray() {
	            var loggerNames = Array.from(this._loggerMap.keys());
	            loggerNames.sort();
	            return loggerNames;
	        }
	
	        /**
	         * Get textual name for the default log level.
	         *
	         * Intended for debugging. The format of the string may change.
	         *
	         * @returns {string}
	         */
	
	    }, {
	        key: "getTextualNameForDefaultLogLevel",
	        value: function getTextualNameForDefaultLogLevel() {
	            return _loglevel2.default.getTextualNameForLogLevel(this.getDefaultLogLevel());
	        }
	
	        /**
	         * Get a string that summarize information about all the
	         * loggers. The string has a list of loglevels with
	         * their loglevel. Perfect for debugging.
	         *
	         * Intended for debugging. The format of the string may change.
	         *
	         * @returns {string}
	         */
	
	    }, {
	        key: "getDebugInfoString",
	        value: function getDebugInfoString() {
	            var loggerInfoString = "Default logLevel: " + (this.getTextualNameForDefaultLogLevel() + "\n") + "Loggers:\n";
	            if (this.getLoggerCount() === 0) {
	                loggerInfoString += '(no loggers)\n';
	            } else {
	                var _iteratorNormalCompletion = true;
	                var _didIteratorError = false;
	                var _iteratorError = undefined;
	
	                try {
	                    for (var _iterator = this.getLoggerNameArray()[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                        var loggerName = _step.value;
	
	                        var logger = this.getLogger(loggerName);
	                        loggerInfoString += " - " + logger.getDebugInfoString() + "\n";
	                    }
	                } catch (err) {
	                    _didIteratorError = true;
	                    _iteratorError = err;
	                } finally {
	                    try {
	                        if (!_iteratorNormalCompletion && _iterator.return) {
	                            _iterator.return();
	                        }
	                    } finally {
	                        if (_didIteratorError) {
	                            throw _iteratorError;
	                        }
	                    }
	                }
	            }
	            return loggerInfoString;
	        }
	    }]);
	
	    return LoggerSingleton;
	}();
	
	exports.default = LoggerSingleton;

/***/ }),

/***/ 4:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Defines valid log levels.
	 *
	 * Not used directly, but instead via the LOGLEVEL
	 * constant exported as default by this module.
	 *
	 * @example
	 * import LOGLEVEL from 'ievv_jsbase/log/loglevel';
	 * console.log('The debug loglevel is:', LOGLEVEL.DEBUG);
	 * LOGLEVEL.validateLogLevel(10);
	 */
	var LogLevels = exports.LogLevels = function () {
	    function LogLevels() {
	        _classCallCheck(this, LogLevels);
	
	        this._prettyLogLevelNames = {};
	        this._prettyLogLevelNames[this.DEBUG] = 'DEBUG';
	        this._prettyLogLevelNames[this.INFO] = 'INFO';
	        this._prettyLogLevelNames[this.WARNING] = 'WARNING';
	        this._prettyLogLevelNames[this.ERROR] = 'ERROR';
	        this._prettyLogLevelNames[this.SILENT] = 'SILENT';
	    }
	
	    /**
	     * Get the number for log level DEBUG.
	     * @returns {number}
	     */
	
	
	    _createClass(LogLevels, [{
	        key: 'validateLogLevel',
	
	
	        /**
	         * Validate a log level.
	         *
	         * Should be used by all functions/methods that set a log level.
	         *
	         * @param logLevel The loglevel.
	         * @throws {RangeError} If ``logLevel`` is not one
	         *   of:
	         *
	         *   - {@link LogLevels#DEBUG}
	         *   - {@link LogLevels#INFO}
	         *   - {@link LogLevels#WARNING}
	         *   - {@link LogLevels#ERROR}
	         *   - {@link LogLevels#SILENT}
	         */
	        value: function validateLogLevel(logLevel) {
	            if (logLevel > this.DEBUG || logLevel < this.SILENT) {
	                throw new RangeError('Invalid log level: ' + logLevel + ', must be between ' + (this.SILENT + ' (SILENT) and ' + this.DEBUG + ' (DEBUG)'));
	            }
	        }
	
	        /**
	         * Get the textual name for a log level.
	         *
	         * @param {number} logLevel The log level to get a textual name for.
	         * @returns {string}
	         *
	         * @example
	         * const infoText = LOGLEVEL.getTextualNameForLogLevel(LOGLEVEL.INFO);
	         * // infoText === 'INFO'
	         */
	
	    }, {
	        key: 'getTextualNameForLogLevel',
	        value: function getTextualNameForLogLevel(logLevel) {
	            return this._prettyLogLevelNames[logLevel];
	        }
	    }, {
	        key: 'DEBUG',
	        get: function get() {
	            return 4;
	        }
	
	        /**
	         * Get the number for log level INFO.
	         * @returns {number}
	         */
	
	    }, {
	        key: 'INFO',
	        get: function get() {
	            return 3;
	        }
	
	        /**
	         * Get the number for log level WARNING.
	         * @returns {number}
	         */
	
	    }, {
	        key: 'WARNING',
	        get: function get() {
	            return 2;
	        }
	
	        /**
	         * Get the number for log level ERROR.
	         * @returns {number}
	         */
	
	    }, {
	        key: 'ERROR',
	        get: function get() {
	            return 1;
	        }
	
	        /**
	         * Get the number for log level SILENT.
	         * @returns {number}
	         */
	
	    }, {
	        key: 'SILENT',
	        get: function get() {
	            return 0;
	        }
	    }]);
	
	    return LogLevels;
	}();
	
	var LOGLEVEL = new LogLevels();
	exports.default = LOGLEVEL;

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.default = makeCustomError;
	/**
	 * Make a custom error "class".
	 *
	 * Makes an old style prototype based error class.
	 *
	 * @example <caption>Typical usage</caption>
	 * // In myerrors.js
	 * export let MyCustomError = makeCustomError('MyCustomError');
	 *
	 * // Using the error
	 * import {MyCustomError} from './myerrors';
	 * throw new MyCustomError('The message');
	 *
	 * @example <caption>Throwing the error - complete example</caption>
	 * try {
	 *     throw new MyCustomError('The message', {
	 *          code: 'stuff_happened',
	 *          details: {
	 *              size: 10
	 *          }
	 *     });
	 * } catch(e) {
	 *     if(e instanceof MyCustomError) {
	 *         console.error(`${e.toString()} -- Code: ${e.code}. Size: ${e.details.size}`);
	 *     }
	 * }
	 *
	 * @example <caption>Define an error that extends Error</caption>
	 * let NotFoundError = makeCustomError('NotFoundError');
	 * // error instanceof NotFoundError === true
	 * // error instanceof Error === true
	 *
	 * @example <caption>Define an error that extends a built in error</caption>
	 * let MyValueError = makeCustomError('MyValueError', TypeError);
	 * let error = new MyValueError();
	 * // error instanceof MyValueError === true
	 * // error instanceof TypeError === true
	 * // error instanceof Error === true
	 *
	 * @example <caption>Define an error that extends another custom error</caption>
	 * let MySuperError = makeCustomError('MySuperError', TypeError);
	 * let MySubError = makeCustomError('MySubError', MySuperError);
	 * let error = new MySubError();
	 * // error instanceof MySubError === true
	 * // error instanceof MySuperError === true
	 * // error instanceof TypeError === true
	 * // error instanceof Error === true
	 *
	 * @param {string} name The name of the error class.
	 * @param {Error} extendsError An optional Error to extend.
	 *      Defaults to {@link Error}. Can be a built in error
	 *      or a custom error created by this function.
	 * @returns {Error} The created error class.
	 */
	function makeCustomError(name, extendsError) {
	    extendsError = extendsError || Error;
	    var CustomError = function CustomError(message, properties) {
	        this.message = message;
	        var last_part = new extendsError().stack.match(/[^\s]+$/);
	        this.stack = this.name + " at " + last_part;
	        if (typeof properties !== 'undefined') {
	            Object.assign(this, properties);
	        }
	    };
	    Object.setPrototypeOf(CustomError, extendsError);
	    CustomError.prototype = Object.create(extendsError.prototype);
	    CustomError.prototype.constructor = CustomError;
	    CustomError.prototype.message = "";
	    CustomError.prototype.name = name;
	    return CustomError;
	}

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	exports.default = typeDetect;
	/**
	 * Detect the type of an object and return the
	 * result as a string.
	 *
	 * Handles the following types:
	 *
	 * - null  (returned as ``"null"``).
	 * - undefined  (returned as ``"undefined"``).
	 * - Number  (returned as ``"number"``).
	 * - Boolean  (returned as ``"boolean"``).
	 * - String  (returned as ``"string"``).
	 * - Array  (returned as ``"array"``).
	 * - Map  (returned as ``"map"``).
	 * - Set  (returned as ``"set"``).
	 * - Function  (returned as ``"function"``).
	 * - Object  (returned as ``"object"``).
	 *
	 * We do not handle classes - they are returned as ``"function"``.
	 * We could handle classes, but for Babel classes that will require
	 * a fairly expensive and error prone regex.
	 *
	 * @param obj An object to detect the type for.
	 * @returns {string}
	 */
	function typeDetect(obj) {
	    if (obj === null) {
	        return 'null';
	    }
	    var typeOf = typeof obj === 'undefined' ? 'undefined' : _typeof(obj);
	    if (typeOf === 'undefined') {
	        return 'undefined';
	    }
	    if (typeOf === 'number') {
	        return 'number';
	    }
	    if (typeOf === 'boolean') {
	        return 'boolean';
	    }
	    if (typeOf === 'string') {
	        return 'string';
	    }
	    if (typeOf === 'function') {
	        return 'function';
	    }
	    if (Array.isArray(obj)) {
	        return 'array';
	    }
	    if (obj instanceof Map) {
	        return 'map';
	    }
	    if (obj instanceof Set) {
	        return 'set';
	    }
	    return 'object';
	}

/***/ }),

/***/ 8:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HttpResponseError = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _makeCustomError = __webpack_require__(5);
	
	var _makeCustomError2 = _interopRequireDefault(_makeCustomError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Error class created by {@link HttpResponse#toError}.
	 *
	 * @type {Error}
	 */
	var HttpResponseError = exports.HttpResponseError = (0, _makeCustomError2.default)('HttpResponseError');
	
	/**
	 * HTTP response.
	 *
	 * Wraps a XMLHttpRequest to make it easier to get
	 * information about the response from the server.
	 */
	
	var HttpResponse = function () {
	    /**
	     *
	     * @param request A XMLHttpRequest object.
	     */
	    function HttpResponse(request) {
	        _classCallCheck(this, HttpResponse);
	
	        this.request = request;
	    }
	
	    /**
	     * Returns ``true`` if {@link HttpResponse#status} is
	     * 200 or larger and less than 300.
	     */
	
	
	    _createClass(HttpResponse, [{
	        key: "isSuccess",
	        value: function isSuccess() {
	            return this.status >= 200 && this.status < 300;
	        }
	
	        /**
	         * Returns ``true`` if {@link HttpResponse#status} is
	         * 300 or larger and less than 400.
	         */
	
	    }, {
	        key: "isRedirect",
	        value: function isRedirect() {
	            return this.status >= 300 && this.status < 400;
	        }
	
	        /**
	         * Returns ``true`` if {@link HttpResponse#status} is
	         * 400 or larger and less than 500.
	         */
	
	    }, {
	        key: "isClientError",
	        value: function isClientError() {
	            return this.status >= 400 && this.status < 500;
	        }
	
	        /**
	         * Returns ``true`` if {@link HttpResponse#status} is
	         * 500 or larger.
	         */
	
	    }, {
	        key: "isServerError",
	        value: function isServerError() {
	            return this.status >= 500;
	        }
	
	        /**
	         * Returns ``true`` if {@link HttpResponse#status} is 0.
	         * Assuming the XMLHttpRequest was actually sent, this
	         * means that the connection was refused.
	         */
	
	    }, {
	        key: "isConnectionRefused",
	        value: function isConnectionRefused() {
	            return this.status === 0;
	        }
	
	        /**
	         * Get the status code of the response (the status attribute of the XMLHttpRequest).
	         */
	
	    }, {
	        key: "responseHeaderToString",
	
	
	        /**
	         * Get the response header as string.
	         */
	        value: function responseHeaderToString() {
	            if (this.connectionRefused) {
	                return "ERROR: Connection refused";
	            } else {
	                return "HTTP " + this.status + "\n" + this.request.getAllResponseHeaders();
	            }
	        }
	
	        /**
	         * Create a {@link HttpResponseError} from this HttpResponse.
	         *
	         * @returns {HttpResponseError} An HttpResponseError with this HttpResponse
	         *      as the ``response`` property.
	         */
	
	    }, {
	        key: "toError",
	        value: function toError() {
	            return new HttpResponseError(this.toString(), {
	                response: this
	            });
	        }
	
	        /**
	         * Get {@link HttpResponse#body} pretty formatted.
	         *
	         * By default, this just returns {@link HttpResponse#body}
	         * but subclasses can override this to prettify the body
	         * if they know the output format of the body.
	         */
	
	    }, {
	        key: "getPrettyfiedBody",
	        value: function getPrettyfiedBody() {
	            return this.body;
	        }
	
	        /**
	         * Format as a string suitable for debugging.
	         */
	
	    }, {
	        key: "toString",
	        value: function toString() {
	            return this.responseHeaderToString() + "\n\n" + this.getPrettyfiedBody();
	        }
	    }, {
	        key: "status",
	        get: function get() {
	            return this.request.status;
	        }
	
	        /**
	         * Get the response body (the responseText attribute of the XMLHttpRequest).
	         */
	
	    }, {
	        key: "body",
	        get: function get() {
	            return this.request.responseText;
	        }
	    }]);
	
	    return HttpResponse;
	}();
	
	exports.default = HttpResponse;

/***/ }),

/***/ 9:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.ElementIsNotInitializedAsWidget = exports.InvalidWidgetAliasError = exports.ElementIsNotWidgetError = exports.ElementHasNoWidgetInstanceIdError = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _makeCustomError = __webpack_require__(5);
	
	var _makeCustomError2 = _interopRequireDefault(_makeCustomError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * The instance of the {@link WidgetRegistrySingleton}.
	 */
	var _instance = null;
	
	/**
	 * Exception thrown when an element where we expect the
	 * ``data-ievv-jsbase-widget-instanceid`` attribute does
	 * not have this attribute.
	 *
	 * @type {Error}
	 */
	var ElementHasNoWidgetInstanceIdError = exports.ElementHasNoWidgetInstanceIdError = (0, _makeCustomError2.default)('ElementHasNoWidgetInstanceIdError');
	
	/**
	 * Exception thrown when an element that we expect to have
	 * the ``data-ievv-jsbase-widget`` attribute does not have
	 * this attribute.
	 *
	 * @type {Error}
	 */
	var ElementIsNotWidgetError = exports.ElementIsNotWidgetError = (0, _makeCustomError2.default)('ElementIsNotWidgetError');
	
	/**
	 * Exception thrown when an element has a
	 * ``data-ievv-jsbase-widget`` with a value that
	 * is not an alias registered in the {@link WidgetRegistrySingleton}.
	 *
	 * @type {Error}
	 */
	var InvalidWidgetAliasError = exports.InvalidWidgetAliasError = (0, _makeCustomError2.default)('InvalidWidgetAliasError');
	
	/**
	 * Exception thrown when an element with the
	 * ``data-ievv-jsbase-widget-instanceid=<widgetInstanceId>`` attribute is not in
	 * the {@link WidgetRegistrySingleton} with ``<widgetInstanceId>``.
	 *
	 * @type {Error}
	 */
	var ElementIsNotInitializedAsWidget = exports.ElementIsNotInitializedAsWidget = (0, _makeCustomError2.default)('ElementIsNotInitializedAsWidget');
	
	/**
	 * A very lightweight widget system.
	 *
	 * Basic example below - see {@link AbstractWidget} for more examples.
	 *
	 * @example <caption>Create a very simple widget</caption>
	 * export default class OpenMenuWidget extends AbstractWidget {
	 *     constructor(element) {
	 *          super(element);
	 *          this._onClickBound = (...args) => {
	 *              this._onClick(...args);
	 *          };
	 *          this.element.addEventListener('click', this._onClickBound);
	 *     }
	 *
	 *     _onClick = (e) => {
	 *          e.preventDefault();
	 *          console.log('I should have opened the menu here');
	 *     }
	 *
	 *     destroy() {
	 *          this.element.removeEventListener('click', this._onClickBound);
	 *     }
	 * }
	 *
	 * @example <caption>Use the widget</caption>
	 * <button data-ievv-jsbase-widget="open-menu-button" type="button">
	 *     Open menu
	 * </button>
	 *
	 * @example <caption>Register and load widgets</caption>
	 * // Somewhere that is called after all the widgets are rendered
	 * // - typically at the end of the <body>
	 * import WidgetRegistrySingleton from 'ievv_jsbase/widget/WidgetRegistrySingleton';
	 * import OpenMenuWidget from 'path/to/OpenMenuWidget';
	 * const widgetRegistry = new WidgetRegistrySingleton();
	 * widgetRegistry.registerWidgetClass('open-menu-button', OpenMenuWidget);
	 * widgetRegistry.initializeAllWidgetsWithinElement(document.body);
	 *
	 */
	
	var WidgetRegistrySingleton = function () {
	    function WidgetRegistrySingleton() {
	        _classCallCheck(this, WidgetRegistrySingleton);
	
	        if (!_instance) {
	            _instance = this;
	            this._initialize();
	        }
	        return _instance;
	    }
	
	    _createClass(WidgetRegistrySingleton, [{
	        key: '_initialize',
	        value: function _initialize() {
	            this._widgetAttribute = 'data-ievv-jsbase-widget';
	            this._widgetInstanceIdAttribute = 'data-ievv-jsbase-widget-instanceid';
	            this._widgetClassMap = new Map();
	            this._widgetInstanceMap = new Map();
	            this._widgetInstanceCounter = 0;
	        }
	    }, {
	        key: 'clear',
	        value: function clear() {
	            // TODO: Call destroyAllWidgetsWithinDocumentBody()
	            this._widgetClassMap.clear();
	            this._widgetInstanceMap.clear();
	            this._widgetInstanceCounter = 0;
	        }
	
	        /**
	         * Register a widget class in the registry.
	         *
	         * @param {string} alias The alias for the widget. This is the string that
	         *      is used as the attribute value with the ``data-ievv-jsbase-widget``
	         *      DOM element attribute.
	         * @param {AbstractWidget} WidgetClass The widget class.
	         */
	
	    }, {
	        key: 'registerWidgetClass',
	        value: function registerWidgetClass(alias, WidgetClass) {
	            this._widgetClassMap.set(alias, WidgetClass);
	        }
	
	        /**
	         * Remove widget class from registry.
	         *
	         * @param alias The alias that the widget class was registered with
	         *      by using {@link WidgetRegistrySingleton#registerWidgetClass}.
	         */
	
	    }, {
	        key: 'removeWidgetClass',
	        value: function removeWidgetClass(alias) {
	            this._widgetClassMap.delete(alias);
	        }
	
	        /**
	         * Initialize the provided element as a widget.
	         *
	         * @param {Element} element The DOM element to initalize as a widget.
	         *
	         * @throws {ElementIsNotWidgetError} If the element does not have
	         *      the ``data-ievv-jsbase-widget`` attribute.
	         * @throws {InvalidWidgetAliasError} If the widget alias is not in this registry.
	         */
	
	    }, {
	        key: 'initializeWidget',
	        value: function initializeWidget(element) {
	            var alias = element.getAttribute(this._widgetAttribute);
	            if (!alias) {
	                throw new ElementIsNotWidgetError('The\n\n' + element.outerHTML + '\n\nelement has no or empty' + (this._widgetAttribute + ' attribute.'));
	            }
	            if (!this._widgetClassMap.has(alias)) {
	                throw new InvalidWidgetAliasError('No WidgetClass registered with the "' + alias + '" alias.');
	            }
	            var WidgetClass = this._widgetClassMap.get(alias);
	            this._widgetInstanceCounter++;
	            var widgetInstanceId = this._widgetInstanceCounter.toString();
	            var widget = new WidgetClass(element, widgetInstanceId);
	            this._widgetInstanceMap.set(widgetInstanceId, widget);
	            element.setAttribute(this._widgetInstanceIdAttribute, widgetInstanceId);
	            return widget;
	        }
	    }, {
	        key: '_getAllWidgetElementsWithinElement',
	        value: function _getAllWidgetElementsWithinElement(element) {
	            return Array.from(element.querySelectorAll('[' + this._widgetAttribute + ']'));
	        }
	
	        /**
	         * Initialize all widgets within the provided element.
	         *
	         * @param {Element} element A DOM element.
	         */
	
	    }, {
	        key: 'initializeAllWidgetsWithinElement',
	        value: function initializeAllWidgetsWithinElement(element) {
	            var afterInitializeAllWidgets = [];
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = this._getAllWidgetElementsWithinElement(element)[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var widgetElement = _step.value;
	
	                    var widget = this.initializeWidget(widgetElement);
	                    if (widget.useAfterInitializeAllWidgets()) {
	                        afterInitializeAllWidgets.push(widget);
	                    }
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = afterInitializeAllWidgets[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var _widget = _step2.value;
	
	                    _widget.afterInitializeAllWidgets();
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	        }
	
	        /**
	         * Get the value of the ``data-ievv-jsbase-widget-instanceid`` attribute
	         * of the provided element.
	         *
	         * @param {Element} element A DOM element.
	         * @returns {null|string}
	         */
	
	    }, {
	        key: 'getWidgetInstanceIdFromElement',
	        value: function getWidgetInstanceIdFromElement(element) {
	            return element.getAttribute(this._widgetInstanceIdAttribute);
	        }
	
	        /**
	         * Get a widget instance by its widget instance id.
	         *
	         * @param widgetInstanceId A widget instance id.
	         * @returns {AbstractWidget} A widget instance or ``null``.
	         */
	
	    }, {
	        key: 'getWidgetInstanceByInstanceId',
	        value: function getWidgetInstanceByInstanceId(widgetInstanceId) {
	            return this._widgetInstanceMap.get(widgetInstanceId);
	        }
	    }, {
	        key: 'getWidgetInstanceFromElement',
	        value: function getWidgetInstanceFromElement(element) {
	            var widgetInstanceId = this.getWidgetInstanceIdFromElement(element);
	            if (widgetInstanceId) {
	                var widgetInstance = this.getWidgetInstanceByInstanceId(widgetInstanceId);
	                if (widgetInstance) {
	                    return widgetInstance;
	                } else {
	                    throw new ElementIsNotInitializedAsWidget('Element\n\n' + element.outerHTML + '\n\nhas the ' + (this._widgetInstanceIdAttribute + ' attribute, but the id is ') + 'not in the widget registry.');
	                }
	            } else {
	                throw new ElementHasNoWidgetInstanceIdError('Element\n\n' + element.outerHTML + '\n\nhas no or empty ' + (this._widgetInstanceIdAttribute + ' attribute.'));
	            }
	        }
	
	        /**
	         * Destroy the widget on the provided element.
	         *
	         * @param {Element} element A DOM element that has been initialized by
	         *      {@link WidgetRegistrySingleton#initializeWidget}.
	         *
	         * @throws {ElementHasNoWidgetInstanceIdError} If the element has
	         *      no ``data-ievv-jsbase-widget-instanceid`` attribute or the
	         *      attribute value is empty. This normally means that
	         *      the element is not a widget, or that the widget
	         *      is not initialized.
	         * @throws {ElementIsNotInitializedAsWidget} If the element
	         *      has the ``data-ievv-jsbase-widget-instanceid`` attribute
	         *      but the value of the attribute is not a valid widget instance
	         *      id. This should not happen unless you manipulate the
	         *      attribute manually or use the private members of this registry.
	         */
	
	    }, {
	        key: 'destroyWidget',
	        value: function destroyWidget(element) {
	            var widgetInstanceId = this.getWidgetInstanceIdFromElement(element);
	            if (widgetInstanceId) {
	                var widgetInstance = this.getWidgetInstanceByInstanceId(widgetInstanceId);
	                if (widgetInstance) {
	                    widgetInstance.destroy();
	                    this._widgetInstanceMap.delete(widgetInstanceId);
	                    element.removeAttribute(this._widgetInstanceIdAttribute);
	                } else {
	                    throw new ElementIsNotInitializedAsWidget('Element\n\n' + element.outerHTML + '\n\nhas the ' + (this._widgetInstanceIdAttribute + ' attribute, but the id is ') + 'not in the widget registry.');
	                }
	            } else {
	                throw new ElementHasNoWidgetInstanceIdError('Element\n\n' + element.outerHTML + '\n\nhas no or empty ' + (this._widgetInstanceIdAttribute + ' attribute.'));
	            }
	        }
	    }, {
	        key: '_getAllInstanciatedWidgetElementsWithinElement',
	        value: function _getAllInstanciatedWidgetElementsWithinElement(element) {
	            return Array.from(element.querySelectorAll('[' + this._widgetInstanceIdAttribute + ']'));
	        }
	
	        /**
	         * Destroy all widgets within the provided element.
	         * Only destroys widgets on elements that is a child of the element.
	         *
	         * @param {Element} element The DOM Element.
	         */
	
	    }, {
	        key: 'destroyAllWidgetsWithinElement',
	        value: function destroyAllWidgetsWithinElement(element) {
	            var _iteratorNormalCompletion3 = true;
	            var _didIteratorError3 = false;
	            var _iteratorError3 = undefined;
	
	            try {
	                for (var _iterator3 = this._getAllInstanciatedWidgetElementsWithinElement(element)[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	                    var widgetElement = _step3.value;
	
	                    this.destroyWidget(widgetElement);
	                }
	            } catch (err) {
	                _didIteratorError3 = true;
	                _iteratorError3 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion3 && _iterator3.return) {
	                        _iterator3.return();
	                    }
	                } finally {
	                    if (_didIteratorError3) {
	                        throw _iteratorError3;
	                    }
	                }
	            }
	        }
	    }]);
	
	    return WidgetRegistrySingleton;
	}();
	
	exports.default = WidgetRegistrySingleton;

/***/ }),

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	exports.HttpCookieNotFoundError = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _makeCustomError = __webpack_require__(5);
	
	var _makeCustomError2 = _interopRequireDefault(_makeCustomError);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Exception raised by {@link HttpCookies#getStrict} when the cookie is not found.
	 *
	 * @type {Error}
	 */
	var HttpCookieNotFoundError = exports.HttpCookieNotFoundError = (0, _makeCustomError2.default)('HttpCookieNotFoundError');
	
	/**
	 * Makes working with ``document.cookie`` easy.
	 *
	 * @example <caption>Get a cookie named "name"</caption>
	 * import HttpCookies from 'ievv_jsbase/http/HttpCookies';
	 * let cookies = HttpCookies();
	 * let name = cookies.get('name');
	 *
	 * @example <caption>Get a cookie named "pageurl", with a fallback</caption>
	 * import HttpCookies from 'ievv_jsbase/http/HttpCookies';
	 * let cookies = HttpCookies();
	 * let name = cookies.get('pageurl', 'http://example.com');
	 *
	 * @example <caption>Get a cookie named "name" in strict mode</caption>
	 * import HttpCookies from 'ievv_jsbase/http/HttpCookies';
	 * import {HttpCookieNotFoundError} from 'ievv_jsbase/http/HttpCookies';
	 * let cookies = HttpCookies();
	 * try {
	 *     let name = cookies.getStrict('name');
	 * } catch(e) {
	 *     if(e instanceof HttpCookieNotFoundError) {
	 *         console.error('Cookie not found', e);
	 *     } else {
	 *         throw e;
	 *     }
	 * }
	 */
	
	var HttpCookies = function () {
	    /**
	     * @param {string} rawCookies Raw cookies string. This is
	     *      optional - it defaults to ``document.cookie``.
	     */
	    function HttpCookies(rawCookies) {
	        _classCallCheck(this, HttpCookies);
	
	        this.rawCookies = rawCookies || document.cookie;
	        this.cookies = this.__parse();
	    }
	
	    _createClass(HttpCookies, [{
	        key: '__parse',
	        value: function __parse() {
	            var cookies = {};
	            if (this.rawCookies && this.rawCookies !== '') {
	                var cookiesArray = this.rawCookies.split(';');
	                for (var i = 0; i < cookiesArray.length; i++) {
	                    var cookie = cookiesArray[i].trim();
	                    var cookieArray = cookie.split('=', 2);
	                    if (cookieArray.length === 2) {
	                        var name = cookieArray[0];
	                        var value = cookieArray[1];
	                        cookies[name.trim()] = value.trim();
	                    }
	                }
	            }
	            return cookies;
	        }
	
	        /**
	         * Get cookie value.
	         *
	         * @param {string} cookieName The name of the cookie.
	         * @param fallback Fallback value if the cookie with the provided
	         *      ``cookieName`` does not exist.
	         *      Defaults to ``undefined``.
	         * @return {string} The cookie value, or the fallback value if no cookie
	         *      with the provided ``cookieName`` is found.
	         */
	
	    }, {
	        key: 'get',
	        value: function get(cookieName, fallback) {
	            var value = this.cookies[cookieName];
	            if (typeof value === 'undefined') {
	                return fallback;
	            } else {
	                return value;
	            }
	        }
	
	        /**
	         * Get cookie value and throw exception if it is not found.
	         *
	         * @param {string} cookieName The name of the cookie.
	         * @returns {string} The cookie value.
	         * @throws {HttpCookieNotFoundError} If no cookie named ``cookieName`` is found.
	         */
	
	    }, {
	        key: 'getStrict',
	        value: function getStrict(cookieName) {
	            var value = this.get(cookieName);
	            if (typeof value === 'undefined') {
	                throw new HttpCookieNotFoundError('Cookie not found: "' + cookieName + '".');
	            }
	            return value;
	        }
	
	        /**
	         * Check if a cookie is among the parsed cookies.
	         *
	         * @param {string} cookieName The name of the cookie to look for.
	         * @returns {boolean} ``true`` if the cookie is among the parsed cookies.
	         */
	
	    }, {
	        key: 'contains',
	        value: function contains(cookieName) {
	            return typeof this.cookies[cookieName] !== 'undefined';
	        }
	    }]);
	
	    return HttpCookies;
	}();
	
	exports.default = HttpCookies;

/***/ }),

/***/ 11:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _HttpJsonRequest2 = __webpack_require__(12);
	
	var _HttpJsonRequest3 = _interopRequireDefault(_HttpJsonRequest2);
	
	var _HttpCookies = __webpack_require__(10);
	
	var _HttpCookies2 = _interopRequireDefault(_HttpCookies);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Extends HttpJsonRequest with automatic handling
	 * of the Django csrftoken.
	 */
	var HttpDjangoJsonRequest = function (_HttpJsonRequest) {
	  _inherits(HttpDjangoJsonRequest, _HttpJsonRequest);
	
	  /**
	   * @param args Same args as for {@link HttpResponse}.
	   */
	  function HttpDjangoJsonRequest() {
	    var _ref;
	
	    _classCallCheck(this, HttpDjangoJsonRequest);
	
	    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    var _this = _possibleConstructorReturn(this, (_ref = HttpDjangoJsonRequest.__proto__ || Object.getPrototypeOf(HttpDjangoJsonRequest)).call.apply(_ref, [this].concat(args)));
	
	    _this._cookies = new _HttpCookies2.default();
	    return _this;
	  }
	
	  /**
	   * Returns the value of the ``csrftoken`` cookie.
	   */
	
	
	  _createClass(HttpDjangoJsonRequest, [{
	    key: "setDefaultRequestHeaders",
	
	
	    /**
	     * Ensures the csrftoken cookie value is automatically set in
	     * the ``X-CSRFToken`` header for all requests except GET and HEAD.
	     *
	     * @param method See {@link HttpRequest}.
	     */
	    value: function setDefaultRequestHeaders(method) {
	      _get(HttpDjangoJsonRequest.prototype.__proto__ || Object.getPrototypeOf(HttpDjangoJsonRequest.prototype), "setDefaultRequestHeaders", this).call(this, method);
	      var shouldAddCsrfToken = !(method == 'GET' || method == 'HEAD');
	      if (shouldAddCsrfToken) {
	        this.setRequestHeader("X-CSRFToken", this.csrftoken);
	      }
	    }
	  }, {
	    key: "csrftoken",
	    get: function get() {
	      return this._cookies.getStrict('csrftoken');
	    }
	  }]);
	
	  return HttpDjangoJsonRequest;
	}(_HttpJsonRequest3.default);
	
	exports.default = HttpDjangoJsonRequest;

/***/ }),

/***/ 12:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _get = function get(object, property, receiver) { if (object === null) object = Function.prototype; var desc = Object.getOwnPropertyDescriptor(object, property); if (desc === undefined) { var parent = Object.getPrototypeOf(object); if (parent === null) { return undefined; } else { return get(parent, property, receiver); } } else if ("value" in desc) { return desc.value; } else { var getter = desc.get; if (getter === undefined) { return undefined; } return getter.call(receiver); } };
	
	var _HttpJsonResponse = __webpack_require__(13);
	
	var _HttpJsonResponse2 = _interopRequireDefault(_HttpJsonResponse);
	
	var _HttpRequest2 = __webpack_require__(14);
	
	var _HttpRequest3 = _interopRequireDefault(_HttpRequest2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Extends HttpRequest with transparent JSON request/response handling.
	 */
	var JsonHttpRequest = function (_HttpRequest) {
	  _inherits(JsonHttpRequest, _HttpRequest);
	
	  function JsonHttpRequest() {
	    _classCallCheck(this, JsonHttpRequest);
	
	    return _possibleConstructorReturn(this, (JsonHttpRequest.__proto__ || Object.getPrototypeOf(JsonHttpRequest)).apply(this, arguments));
	  }
	
	  _createClass(JsonHttpRequest, [{
	    key: "makeRequestBody",
	
	    /**
	     * Overridden to automatically convert request data to JSON.
	     */
	    value: function makeRequestBody(data) {
	      return JSON.stringify(data);
	    }
	
	    /**
	     * Overridden to return the response as a
	     * {@link HttpJsonResponse} instead if a HttpResponse.
	     *
	     * @returns {HttpJsonResponse}
	     */
	
	  }, {
	    key: "makeResponse",
	    value: function makeResponse() {
	      return new _HttpJsonResponse2.default(this.request);
	    }
	
	    /**
	     * Overridden to ensure we send the correct content-type header for
	     * json requests.
	     */
	
	  }, {
	    key: "setDefaultRequestHeaders",
	    value: function setDefaultRequestHeaders(method) {
	      _get(JsonHttpRequest.prototype.__proto__ || Object.getPrototypeOf(JsonHttpRequest.prototype), "setDefaultRequestHeaders", this).call(this, method);
	      this.setRequestHeader('Accept', 'application/json');
	      this.setRequestHeader('Content-Type', 'application/json; charset=UTF-8');
	    }
	  }]);
	
	  return JsonHttpRequest;
	}(_HttpRequest3.default);
	
	exports.default = JsonHttpRequest;

/***/ }),

/***/ 13:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HttpResponse2 = __webpack_require__(8);
	
	var _HttpResponse3 = _interopRequireDefault(_HttpResponse2);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	/**
	 * Extends HttpResponse with extra functionality for
	 * working with JSON response data.
	 *
	 * The most important addition is the {@link HttpJsonResponse#bodydata}
	 * property that you will want to use instead of
	 * {@link HttpResponse#body}.
	 */
	var HttpJsonResponse = function (_HttpResponse) {
	    _inherits(HttpJsonResponse, _HttpResponse);
	
	    function HttpJsonResponse() {
	        _classCallCheck(this, HttpJsonResponse);
	
	        return _possibleConstructorReturn(this, (HttpJsonResponse.__proto__ || Object.getPrototypeOf(HttpJsonResponse)).apply(this, arguments));
	    }
	
	    _createClass(HttpJsonResponse, [{
	        key: "__parseResponseTextAsJson",
	        value: function __parseResponseTextAsJson() {
	            return JSON.parse(this.body);
	        }
	
	        /**
	         * Overriden to make use of JSON.stringify to produce more
	         * pretty output.
	         */
	
	    }, {
	        key: "getPrettyfiedBody",
	        value: function getPrettyfiedBody() {
	            var prettyBody = void 0;
	            try {
	                prettyBody = JSON.stringify(this.bodydata, null, 2);
	            } catch (SyntaxError) {
	                prettyBody = this.body;
	            }
	            return prettyBody;
	        }
	    }, {
	        key: "bodydata",
	
	
	        /**
	         * Get the response body (the responseText attribute of the XMLHttpRequest)
	         * decoded from JSON.
	         */
	        get: function get() {
	            if (this.isConnectionRefused()) {
	                return null;
	            } else {
	                return this.__parseResponseTextAsJson();
	            }
	        }
	    }]);
	
	    return HttpJsonResponse;
	}(_HttpResponse3.default);
	
	exports.default = HttpJsonResponse;

/***/ }),

/***/ 14:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _HttpResponse = __webpack_require__(8);
	
	var _HttpResponse2 = _interopRequireDefault(_HttpResponse);
	
	var _UrlParser = __webpack_require__(16);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * API for performing HTTP requests.
	 *
	 * @example <caption>Make a POST request</caption>
	 * const request = new HttpRequest('http://example.com/api/users/');
	 * request.post('Hello world')
	 *     .then((response) => {
	 *         // Success - response is a HttpResponse object.
	 *         console.log(response.toString());
	 *         if(response.isSuccess()) {
	 *             console.log('Success: ', response.body);
	 *         } else if (response.isRedirect) {
	 *             console.log('Hmm strange, we got a redirect instead of a 2xx response.');
	 *         }
	 *     })
	 *     .catch((error) => {
	 *         // Error - response is an HttpResponse object.
	 *         console.error(error.toString());
	 *         if(error.response.isRedirect()) {
	 *             // Yes - redirect is treated as an error by default.
	 *             // you can change this by supplying an extra argument
	 *             // to HttpResponse()
	 *             console.log('We got a 3xx response!', error.response.body);
	 *         } else if(error.response.isClientError()) {
	 *             console.log('We got a 4xx response!', error.response.body);
	 *         } else if (error.response.isServerError()) {
	 *             console.log('We got a 5xx response!', error.response.body);
	 *         } else if (error.response.isConnectionRefused()) {
	 *             console.log('Connection refused.');
	 *         }
	 *         // throw error;  // You can throw the error as an exception
	 *     });
	 *
	 * @example <caption>Make a GET request with a querystring</caption>
	 * const request = new HttpRequest('http://example.com/api/users/');
	 * request.urlParser.queryString.set('search', 'doe');
	 * request.get()
	 *     .then((response) => {
	 *         console.log('Success!', response.toString());
	 *     })
	 *     .catch((error) => {
	 *         console.error('Error:', error.toString());
	 *     });
	 */
	var HttpRequest = function () {
	    /**
	     * @param {string} url The URL to request.
	     *      If this is supplied, it is passed to
	     *      {@link HttpRequest#setUrl}
	     */
	    function HttpRequest(url) {
	        _classCallCheck(this, HttpRequest);
	
	        this._treatRedirectResponseAsError = true;
	        this.request = new XMLHttpRequest();
	        this._urlParser = null;
	        if (typeof url !== 'undefined') {
	            this.setUrl(url);
	        }
	    }
	
	    /**
	     * Get the parsed URL of the request.
	     *
	     * @returns {UrlParser} The UrlParser for the parsed URL.
	     */
	
	
	    _createClass(HttpRequest, [{
	        key: "setUrl",
	
	
	        /**
	         * Set the URL of the request.
	         *
	         * @param {String} url The URL.
	         */
	        value: function setUrl(url) {
	            this._urlParser = new _UrlParser.UrlParser(url);
	        }
	
	        /**
	         * Set how we treat 3xx responses.
	         *
	         * By default they are treated as errors, but you can change
	         * this behavior by calling this function.
	         *
	         * @param {bool} treatRedirectResponseAsError Treat 3xx responses as
	         *      errors?
	         *
	         * @example <caption>Do not treat 3xx responses as error</caption>
	         * const request = HttpRequest('http://example.com/api/');
	         * request.setTreatRedirectResponseAsError(false);
	         */
	
	    }, {
	        key: "setTreatRedirectResponseAsError",
	        value: function setTreatRedirectResponseAsError(treatRedirectResponseAsError) {
	            this._treatRedirectResponseAsError = treatRedirectResponseAsError;
	        }
	
	        /**
	         * Send the request.
	         *
	         * @param method The HTTP method. I.e.: "get", "post", ...
	         * @param data Request body data. This is sent through
	         *      {@link HttpRequest#makeRequestBody} before it
	         *      is sent.*
	         * @return A Promise.
	         *
	         *      The resolve function argument is an
	         *      an object of whatever {@link HttpRequest#makeResponse}
	         *      returns.
	         *
	         *      The reject function argument is a
	         *      {@link HttpResponseError} object created using
	         *      {@link HttpResponse#toError}.
	         */
	
	    }, {
	        key: "send",
	        value: function send(method, data) {
	            var _this = this;
	
	            method = method.toUpperCase();
	            if (this._urlParser === null) {
	                throw new TypeError('Can not call send() without an url.');
	            }
	            return new Promise(function (resolve, reject) {
	                _this.request.open(method, _this.urlParser.buildUrl(), true);
	                _this.setDefaultRequestHeaders(method);
	                _this.request.onload = function () {
	                    return _this._onComplete(resolve, reject);
	                };
	                _this.request.onerror = function () {
	                    return _this._onComplete(resolve, reject);
	                };
	                _this.request.send(_this.makeRequestBody(data));
	            });
	        }
	
	        /**
	         * Shortcut for ``send("get", data)``.
	         *
	         * @see {@link HttpRequest#send}
	         */
	
	    }, {
	        key: "get",
	        value: function get(data) {
	            return this.send('get', data);
	        }
	
	        /**
	         * Shortcut for ``send("head", data)``.
	         *
	         * @see {@link HttpRequest#send}
	         */
	
	    }, {
	        key: "head",
	        value: function head(data) {
	            return this.send('head', data);
	        }
	
	        /**
	         * Shortcut for ``send("post", data)``.
	         *
	         * @see {@link HttpRequest#send}
	         */
	
	    }, {
	        key: "post",
	        value: function post(data) {
	            return this.send('post', data);
	        }
	
	        /**
	         * Shortcut for ``send("put", data)``.
	         *
	         * @see {@link HttpRequest#send}
	         */
	
	    }, {
	        key: "put",
	        value: function put(data) {
	            return this.send('put', data);
	        }
	
	        /**
	         * Shortcut for ``send("patch", data)``.
	         *
	         * @see {@link HttpRequest#send}
	         */
	
	    }, {
	        key: "patch",
	        value: function patch(data) {
	            return this.send('patch', data);
	        }
	
	        /**
	         * Shortcut for ``send("delete", data)``.
	         *
	         * Named httpdelete to avoid crash with builtin keyword ``delete``.
	         *
	         * @see {@link HttpRequest#send}
	         */
	
	    }, {
	        key: "httpdelete",
	        value: function httpdelete(data) {
	            return this.send('delete', data);
	        }
	
	        /**
	         * Make request body from the provided data.
	         *
	         * By default this just returns the provided data,
	         * but subclasses can override this to perform automatic
	         * conversion.
	         *
	         * Must return a string.
	         */
	
	    }, {
	        key: "makeRequestBody",
	        value: function makeRequestBody(data) {
	            return data;
	        }
	
	        /**
	         * Creates a {@link HttpResponse}.
	         * @returns {HttpResponse}
	         */
	
	    }, {
	        key: "makeResponse",
	        value: function makeResponse() {
	            return new _HttpResponse2.default(this.request);
	        }
	
	        /**
	         * Set a request header.
	         *
	         * @param header The header name. E.g.: ``"Content-type"``.
	         * @param value The header value.
	         */
	
	    }, {
	        key: "setRequestHeader",
	        value: function setRequestHeader(header, value) {
	            this.request.setRequestHeader(header, value);
	        }
	
	        /**
	         * Set default request headers.
	         *
	         * Does nothing by default, but subclasses can override this.
	         *
	         * @param method The HTTP request method (GET, POST, PUT, ...).
	         *      Will always be uppercase.
	         */
	
	    }, {
	        key: "setDefaultRequestHeaders",
	        value: function setDefaultRequestHeaders(method) {}
	    }, {
	        key: "_onComplete",
	        value: function _onComplete(resolve, reject) {
	            var response = this.makeResponse();
	            var isSuccess = false;
	            if (this._treatRedirectResponseAsError) {
	                isSuccess = response.isSuccess();
	            } else {
	                isSuccess = response.isSuccess() || response.isRedirect();
	            }
	            if (isSuccess) {
	                resolve(response);
	            } else {
	                reject(response.toError());
	            }
	        }
	    }, {
	        key: "urlParser",
	        get: function get() {
	            return this._urlParser;
	        }
	    }]);
	
	    return HttpRequest;
	}();
	
	exports.default = HttpRequest;

/***/ }),

/***/ 15:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }(); /**
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * Query-string creator and parser.
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example <caption>Basics - build a querystring</caption>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const querystring = new QueryString();
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * querystring.set('name', 'Peter');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * querystring.setIterable('tags', ['person', 'male']);
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const encodedQuerystring = querystring.urlencode();
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * // encodedQuerystring === 'name=Peter&tags=person&tags=male'  // order may vary
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example <caption>Parse a querystring</caption>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const querystring = new QueryString('name=Peter&tags=person&tags=male');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const name = querystring.get('name');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const tags = querystring.getArray('tags');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const firstTag = querystring.get('tags');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example <caption>Parse a querystring from window.location.search</caption>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * // window.location.search == "?name=test&age=12"
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const querystring = new QueryString(window.location.search);
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const name = querystring.get('name');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const age = querystring.get('age');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      *
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * @example <caption>Parse and modify a querystring</caption>
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * const querystring = new QueryString('name=Peter&tags=person&tags=male');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * querystring.set('name', 'John');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * querystring.append('tags', 'important');
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * // querystring.urlencode() === 'name=John&tags=person&tags=male&tags=important'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * querystring.setIterable('tags', ['male']);
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      * // querystring.urlencode() === 'name=John&tags=male'
	                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                                      */
	
	
	var _typeDetect = __webpack_require__(6);
	
	var _typeDetect2 = _interopRequireDefault(_typeDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var QueryString = function () {
	  /**
	   *
	   * @param {string} querystring Optional input querystring to parse.
	   */
	  function QueryString() {
	    var querystring = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
	
	    _classCallCheck(this, QueryString);
	
	    this._queryStringMap = new Map();
	    if (querystring) {
	      if (typeof querystring !== 'string') {
	        throw new TypeError('The querystring argument must be a string.');
	      }
	      this._parseQueryString(querystring);
	    }
	  }
	
	  /**
	   * Returns ``true`` if the querystring is empty, otherwise ``false``.
	   *
	   * @returns {boolean}
	   */
	
	
	  _createClass(QueryString, [{
	    key: 'isEmpty',
	    value: function isEmpty() {
	      return this._queryStringMap.size === 0;
	    }
	
	    /**
	     * Remove all keys and values from the QueryString.
	     */
	
	  }, {
	    key: 'clear',
	    value: function clear() {
	      this._queryStringMap.clear();
	    }
	  }, {
	    key: '_parseQueryStringItem',
	    value: function _parseQueryStringItem(querystringItem) {
	      var splitPair = querystringItem.split('=');
	      var key = decodeURIComponent(splitPair[0]);
	      var value = decodeURIComponent(splitPair[1]);
	      this.append(key, value);
	    }
	  }, {
	    key: '_parseQueryString',
	    value: function _parseQueryString(querystring) {
	      if (querystring.substring(0, 1) == '?') {
	        querystring = querystring.substring(1);
	      }
	      var splitQueryString = querystring.split('&');
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = splitQueryString[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var querystringItem = _step.value;
	
	          this._parseQueryStringItem(querystringItem);
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	    }
	  }, {
	    key: '_addToKey',
	    value: function _addToKey(key, value) {
	      this._queryStringMap.get(key).push(value);
	    }
	  }, {
	    key: '_setKeyToEmptyArray',
	    value: function _setKeyToEmptyArray(key) {
	      this._queryStringMap.set(key, []);
	    }
	
	    /**
	     * Set values from a querystring, like window.location.search.
	     *
	     * Overwrites any key/value pairs currently in this object with keys in the
	     * provided ``querystring``.
	     *
	     * @example
	     * const querystring = new QueryString();
	     * querystring.set('name', 'oldname');
	     * querystring.addValuesFromQueryString('name=newname&age=33');
	     * // querystring.get('name') == 'newname'
	     * // querystring.get('age') == '33'
	     *
	     * @param {string} querystring A querystring, like the one in window.location.search.
	     *    Examples: ``"?a=10"``, ``"a=10"``, ``"a=10&s=test"``.
	     */
	
	  }, {
	    key: 'setValuesFromQueryString',
	    value: function setValuesFromQueryString(querystring) {
	      this.merge(new this.constructor(querystring));
	    }
	
	    /**
	     * Set values from an Object.
	     *
	     * Overwrites any key/value pairs currently in this QueryString
	     * with key/value pairs in the provided ``object``.
	     *
	     * Uses {@link QueryString#setSmart} to set the values, so
	     * the values of the map can be both simple types and
	     * iterables like arrays and sets.
	     *
	     * @example
	     * const querystring = new QueryString();
	     * querystring.set('name', 'oldname');
	     * querystring.addValuesFromObject({
	     *   name: 'newname',
	     *   age: 33,
	     *   tags: ['tag1', 'tag2']
	     * });
	     * // querystring.get('name') == 'newname'
	     * // querystring.get('age') == 33
	     * // querystring.getArray('tags') == ['tag1', 'tag2']
	     *
	     * @param {Object} object An Object.
	     */
	
	  }, {
	    key: 'setValuesFromObject',
	    value: function setValuesFromObject(object) {
	      var _iteratorNormalCompletion2 = true;
	      var _didIteratorError2 = false;
	      var _iteratorError2 = undefined;
	
	      try {
	        for (var _iterator2 = Object.keys(object)[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	          var key = _step2.value;
	
	          this.setSmart(key, object[key]);
	        }
	      } catch (err) {
	        _didIteratorError2 = true;
	        _iteratorError2 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion2 && _iterator2.return) {
	            _iterator2.return();
	          }
	        } finally {
	          if (_didIteratorError2) {
	            throw _iteratorError2;
	          }
	        }
	      }
	    }
	
	    /**
	     * Set values from a Map.
	     *
	     * Overwrites any key/value pairs currently in this QueryString
	     * with key/value pairs in the provided ``map``.
	     *
	     * Uses {@link QueryString#setSmart} to set the values, so
	     * the values of the map can be both simple types and
	     * iterables like arrays and sets.
	     *
	     * @example
	     * const querystring = new QueryString();
	     * querystring.set('name', 'oldname');
	     * querystring.addValuesFromMap(new Map([
	     *   ['name', 'newname'],
	     *   ['age', 33],
	     *   ['tags', ['tag1', 'tag2']]
	     * ]));
	     * // querystring.get('name') == 'newname'
	     * // querystring.get('age') == 33
	     * // querystring.getArray('tags') == ['tag1', 'tag2']
	     *
	     * @param {Map} map A map.
	     */
	
	  }, {
	    key: 'setValuesFromMap',
	    value: function setValuesFromMap(map) {
	      var _iteratorNormalCompletion3 = true;
	      var _didIteratorError3 = false;
	      var _iteratorError3 = undefined;
	
	      try {
	        for (var _iterator3 = map.entries()[Symbol.iterator](), _step3; !(_iteratorNormalCompletion3 = (_step3 = _iterator3.next()).done); _iteratorNormalCompletion3 = true) {
	          var _step3$value = _slicedToArray(_step3.value, 2),
	              key = _step3$value[0],
	              value = _step3$value[1];
	
	          this.setSmart(key, value);
	        }
	      } catch (err) {
	        _didIteratorError3 = true;
	        _iteratorError3 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion3 && _iterator3.return) {
	            _iterator3.return();
	          }
	        } finally {
	          if (_didIteratorError3) {
	            throw _iteratorError3;
	          }
	        }
	      }
	    }
	
	    /**
	     * Merge {@link QueryString} objects into with this object.
	     *
	     * Overwrites any key/value pairs currently in this object with keys in the
	     * provided queryStringObjects in provided order, with the last
	     * one overwriting any preceding values.
	     *
	     * @example
	     * const querystring = new QueryString('name=oldname');
	     * querystring.merge(
	     *    new QueryString('name=newname1&age=33'),
	     *    new QueryString('name=newname2&size=large'));
	     * // querystring.get('name') == 'newname2'
	     * // querystring.get('age') == '33'
	     * // querystring.get('size') == 'large'
	     *
	     * @param queryStringObjects Zero or more {@link QueryString} objects.
	     */
	
	  }, {
	    key: 'merge',
	    value: function merge() {
	      for (var _len = arguments.length, queryStringObjects = Array(_len), _key = 0; _key < _len; _key++) {
	        queryStringObjects[_key] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion4 = true;
	      var _didIteratorError4 = false;
	      var _iteratorError4 = undefined;
	
	      try {
	        for (var _iterator4 = queryStringObjects[Symbol.iterator](), _step4; !(_iteratorNormalCompletion4 = (_step4 = _iterator4.next()).done); _iteratorNormalCompletion4 = true) {
	          var queryStringObject = _step4.value;
	          var _iteratorNormalCompletion5 = true;
	          var _didIteratorError5 = false;
	          var _iteratorError5 = undefined;
	
	          try {
	            for (var _iterator5 = queryStringObject._queryStringMap[Symbol.iterator](), _step5; !(_iteratorNormalCompletion5 = (_step5 = _iterator5.next()).done); _iteratorNormalCompletion5 = true) {
	              var _step5$value = _slicedToArray(_step5.value, 2),
	                  key = _step5$value[0],
	                  value = _step5$value[1];
	
	              this._queryStringMap.set(key, value);
	            }
	          } catch (err) {
	            _didIteratorError5 = true;
	            _iteratorError5 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion5 && _iterator5.return) {
	                _iterator5.return();
	              }
	            } finally {
	              if (_didIteratorError5) {
	                throw _iteratorError5;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError4 = true;
	        _iteratorError4 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion4 && _iterator4.return) {
	            _iterator4.return();
	          }
	        } finally {
	          if (_didIteratorError4) {
	            throw _iteratorError4;
	          }
	        }
	      }
	    }
	
	    /**
	     * Set value from an iterable.
	     *
	     * @param {string} key The key to set.
	     * @param iterable Something that can be iterated with a
	     *      ``for(const value of iterable)`` loop.
	     *      All the values in the iterable must be strings.
	     *      If the iterable is empty the key will be removed
	     *      from the QueryString.
	     *
	     * @example
	     * const querystring = QueryString();
	     * querystring.setIterable('names', ['Peter', 'Jane']);
	     */
	
	  }, {
	    key: 'setIterable',
	    value: function setIterable(key, iterable) {
	      this._setKeyToEmptyArray(key);
	      var _iteratorNormalCompletion6 = true;
	      var _didIteratorError6 = false;
	      var _iteratorError6 = undefined;
	
	      try {
	        for (var _iterator6 = iterable[Symbol.iterator](), _step6; !(_iteratorNormalCompletion6 = (_step6 = _iterator6.next()).done); _iteratorNormalCompletion6 = true) {
	          var value = _step6.value;
	
	          this._addToKey(key, value);
	        }
	      } catch (err) {
	        _didIteratorError6 = true;
	        _iteratorError6 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion6 && _iterator6.return) {
	            _iterator6.return();
	          }
	        } finally {
	          if (_didIteratorError6) {
	            throw _iteratorError6;
	          }
	        }
	      }
	
	      if (this._queryStringMap.get(key).length === 0) {
	        this.remove(key);
	      }
	    }
	
	    /**
	     * Set a value.
	     *
	     * @param {string} key The key to store the value as.
	     * @param {string} value The value to set.
	     *
	     * @example
	     * const querystring = QueryString();
	     * querystring.set('name', 'Peter');
	     */
	
	  }, {
	    key: 'set',
	    value: function set(key, value) {
	      this.setIterable(key, [value]);
	    }
	
	    /**
	     * Calls {@link QueryString#set} or {@link QueryString#setIterable} depending
	     * on the type of the provided value.
	     *
	     * @param {string} key The key to store the value as.
	     * @param {string|number|boolean|array|Set} value The value to set using
	     *    {@link QueryString#set} or {@link QueryString#setIterable} depending
	     *    on the type.
	     */
	
	  }, {
	    key: 'setSmart',
	    value: function setSmart(key, value) {
	      var valueType = (0, _typeDetect2.default)(value);
	      if (valueType === 'string' || valueType === 'number' || valueType === 'boolean') {
	        this.set(key, value);
	      } else if (valueType === 'array' || valueType === 'set') {
	        this.setIterable(key, value);
	      } else {
	        throw new Error('Unsupporter value type: ' + valueType);
	      }
	    }
	
	    /**
	     * Get a value.
	     *
	     * @param {string} key The key to get the value for.
	     * @param {string} fallback An optional fallback value if the key is
	     *      not in the QueryString. Defaults to ``undefined``.
	     */
	
	  }, {
	    key: 'get',
	    value: function get(key, fallback) {
	      var value = this._queryStringMap.get(key);
	      if (typeof value === 'undefined') {
	        return fallback;
	      } else {
	        return value[0];
	      }
	    }
	
	    /**
	     * Append a value to a key.
	     *
	     * @param {string} key The key to append a value to.
	     * @param {string} value The value to append.
	     *
	     * @example
	     * const querystring = QueryString();
	     * querystring.append('names', 'Jane');
	     * querystring.append('names', 'Joe');
	     * // querystring.urlencode() === 'names=Jane&names=Joe'
	     */
	
	  }, {
	    key: 'append',
	    value: function append(key, value) {
	      if (!this._queryStringMap.has(key)) {
	        this._setKeyToEmptyArray(key);
	      }
	      this._addToKey(key, value);
	    }
	
	    /**
	     * Get the values for the specified key as an array.
	     *
	     * Always returns an array, even if the value was set
	     * with {@link QueryString#set}.
	     *
	     * @param {string} key The key to get the values for.
	     * @param {Array} fallback An optional fallback value if they
	     *      key is not in the QueryString. Defaults to an empty array.
	     * @returns {Array}
	     */
	
	  }, {
	    key: 'getArray',
	    value: function getArray(key, fallback) {
	      if (this._queryStringMap.has(key)) {
	        var valueArray = this._queryStringMap.get(key);
	        return Array.from(valueArray);
	      }
	      if (typeof falback !== 'undefined') {
	        return [];
	      }
	      return fallback;
	    }
	
	    /**
	     * Remove the specified key from the QueryString.
	     *
	     * @param {string} key The key to remove.
	     */
	
	  }, {
	    key: 'remove',
	    value: function remove(key) {
	      this._queryStringMap.delete(key);
	    }
	
	    /**
	     * Check if the QueryString contains the given key.
	     *
	     * @param {string} key The key to check for.
	     * @returns {boolean}
	     */
	
	  }, {
	    key: 'has',
	    value: function has(key) {
	      return this._queryStringMap.has(key);
	    }
	  }, {
	    key: '_encodeKeyValue',
	    value: function _encodeKeyValue(key, value) {
	      key = '' + key;
	      value = '' + value;
	      return encodeURIComponent(key) + '=' + encodeURIComponent(value);
	    }
	
	    /**
	     * Get the QueryString object as a string in query-string format.
	     *
	     * @example
	     * const querystring = QueryString();
	     * querystring.set('next', '/a&b/');
	     * querystring.set('name', 'john');
	     * let urlEncodedQuerystring = querystring.urlencode();
	     * // urlEncodedQuerystring === 'name=john&next=%2Fa%26b%2F'  // order may vary
	     *
	     * @example <caption>Sort keys</caption>
	     * const querystring = QueryString();
	     * querystring.set('name', 'john');
	     * querystring.set('age', 33);
	     * let urlEncodedQuerystring = querystring.urlencode({sortKeys: true});
	     * // urlEncodedQuerystring === 'age=33&name=john'
	     *
	     * @example <caption>Sort values</caption>
	     * const querystring = QueryString();
	     * querystring.setIterable('name', ['john', 'amy', 'xion']);
	     * let urlEncodedQuerystring = querystring.urlencode();
	     * // urlEncodedQuerystring === 'name=amy&name=john&name=xion'
	     *
	     *
	     * @param {Object} options Options. All are optional
	     * @param {boolean} options.sortKeys Sort the keys using Array.sort? ``false`` by default.
	     * @param {boolean} options.sortValues Sort the values using Array.sort? ``false`` by default.
	     *    This only makes sense if you have keys with multiple values.
	     * @param {boolean} options.skipEmptyValues Skip empty values? ``false`` by default.
	     */
	
	  }, {
	    key: 'urlencode',
	    value: function urlencode() {
	      var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      var sortKeys = options.sortKeys,
	          sortValues = options.sortValues,
	          skipEmptyValues = options.skipEmptyValues;
	
	      var keys = this._queryStringMap.keys();
	      if (sortKeys) {
	        keys = Array.from(keys);
	        keys.sort();
	      }
	
	      var urlEncodedArray = [];
	      var _iteratorNormalCompletion7 = true;
	      var _didIteratorError7 = false;
	      var _iteratorError7 = undefined;
	
	      try {
	        for (var _iterator7 = keys[Symbol.iterator](), _step7; !(_iteratorNormalCompletion7 = (_step7 = _iterator7.next()).done); _iteratorNormalCompletion7 = true) {
	          var key = _step7.value;
	
	          var valueArray = this._queryStringMap.get(key);
	          if (sortValues) {
	            valueArray = Array.from(valueArray);
	            valueArray.sort();
	          }
	          var _iteratorNormalCompletion8 = true;
	          var _didIteratorError8 = false;
	          var _iteratorError8 = undefined;
	
	          try {
	            for (var _iterator8 = valueArray[Symbol.iterator](), _step8; !(_iteratorNormalCompletion8 = (_step8 = _iterator8.next()).done); _iteratorNormalCompletion8 = true) {
	              var value = _step8.value;
	
	              if (skipEmptyValues && '' + value === '') {
	                continue;
	              }
	              urlEncodedArray.push(this._encodeKeyValue(key, value));
	            }
	          } catch (err) {
	            _didIteratorError8 = true;
	            _iteratorError8 = err;
	          } finally {
	            try {
	              if (!_iteratorNormalCompletion8 && _iterator8.return) {
	                _iterator8.return();
	              }
	            } finally {
	              if (_didIteratorError8) {
	                throw _iteratorError8;
	              }
	            }
	          }
	        }
	      } catch (err) {
	        _didIteratorError7 = true;
	        _iteratorError7 = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion7 && _iterator7.return) {
	            _iterator7.return();
	          }
	        } finally {
	          if (_didIteratorError7) {
	            throw _iteratorError7;
	          }
	        }
	      }
	
	      return urlEncodedArray.join('&');
	    }
	  }]);
	
	  return QueryString;
	}();
	
	exports.default = QueryString;

/***/ }),

/***/ 16:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.UrlParser = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _QueryString = __webpack_require__(15);
	
	var _QueryString2 = _interopRequireDefault(_QueryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * URL parser.
	 *
	 * @example
	 * const urlparser = new UrlParser('http://example.com/api/people?name=Jane');
	 * urlparser.queryString.set('search', 'doe');
	 * // urlparser.buildUrl() === 'http://example.com/api/people?name=Jane&search=doe'
	 */
	var UrlParser = exports.UrlParser = function () {
	  _createClass(UrlParser, null, [{
	    key: 'pathJoin',
	
	
	    /**
	     * Join URL paths.
	     *
	     * @example
	     * UrlParser.pathJoin('/test', 'user/')  // == '/test/user/'
	     * UrlParser.pathJoin('/test/', 'user/')  // == '/test/user/'
	     * UrlParser.pathJoin('/test/', '/user/')  // == '/test/user/'
	     * UrlParser.pathJoin('/test')  // == '/test'
	     * UrlParser.pathJoin('http://example.com/test/', '/user/', 10) // == http://example.com/test/user/10
	     *
	     * @param firstPath The first path. Can be an URL.
	     * @param paths Paths to join with the first path.
	     * @returns {string} The resulting path/url after joining.
	     */
	    value: function pathJoin(firstPath) {
	      var outputPath = firstPath;
	
	      for (var _len = arguments.length, paths = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	        paths[_key - 1] = arguments[_key];
	      }
	
	      var _iteratorNormalCompletion = true;
	      var _didIteratorError = false;
	      var _iteratorError = undefined;
	
	      try {
	        for (var _iterator = paths[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	          var path = _step.value;
	
	          path = '' + path;
	          if (outputPath.endsWith('/')) {
	            outputPath = outputPath.substring(0, outputPath.length - 1);
	          }
	          if (path.startsWith('/')) {
	            path = path.substring(1);
	          }
	          outputPath = outputPath + '/' + path;
	        }
	      } catch (err) {
	        _didIteratorError = true;
	        _iteratorError = err;
	      } finally {
	        try {
	          if (!_iteratorNormalCompletion && _iterator.return) {
	            _iterator.return();
	          }
	        } finally {
	          if (_didIteratorError) {
	            throw _iteratorError;
	          }
	        }
	      }
	
	      return outputPath;
	    }
	  }]);
	
	  function UrlParser(url) {
	    _classCallCheck(this, UrlParser);
	
	    if (typeof url !== 'string') {
	      throw new TypeError('url must be a string.');
	    }
	    var urlSplit = url.split('?');
	    this._baseUrl = urlSplit[0];
	    this._parsedBaseUrl = this._parseBaseUrl();
	
	    /**
	     * The query-string of the the URL.
	     * @type {QueryString}
	     */
	    this.queryString = null;
	
	    if (urlSplit.length > 1) {
	      this.setQueryString(new _QueryString2.default(urlSplit[1]));
	    } else {
	      this.setQueryString(new _QueryString2.default());
	    }
	  }
	
	  _createClass(UrlParser, [{
	    key: '_splitDomainAndPath',
	    value: function _splitDomainAndPath(domainAndPath) {
	      var split = domainAndPath.split('/');
	      var domain = split.shift();
	      var path = '';
	      if (split.length > 0) {
	        path = '/' + split.join('/');
	      }
	      return {
	        domain: domain,
	        path: path
	      };
	    }
	  }, {
	    key: '_parseBaseUrl',
	    value: function _parseBaseUrl() {
	      var parsedBaseUrl = {
	        scheme: null,
	        path: '',
	        domain: null
	      };
	      if (this._baseUrl.match(/^[a-zA-Z0-9]+:\/\//)) {
	        // We have a full URL (<scheme>://<domain><path>)
	        var split = this._baseUrl.split('://');
	        parsedBaseUrl.scheme = split.shift();
	        var remaining = split.join('://');
	        var domainAndPath = this._splitDomainAndPath(remaining);
	        parsedBaseUrl.domain = domainAndPath.domain;
	        parsedBaseUrl.path = domainAndPath.path;
	      } else if (this._baseUrl.length > 0 && this._baseUrl.substring(0, 1) == '/') {
	        // We have path only
	        parsedBaseUrl.path = '' + this._baseUrl;
	      } else {
	        // We have domain and path, but no scheme (<domain><path>)
	        var _domainAndPath = this._splitDomainAndPath(this._baseUrl);
	        parsedBaseUrl.domain = _domainAndPath.domain;
	        parsedBaseUrl.path = _domainAndPath.path;
	      }
	      return parsedBaseUrl;
	    }
	  }, {
	    key: 'buildUrl',
	
	
	    /**
	     * Build the URL.
	     * @returns {String} The built URL.
	     */
	    value: function buildUrl() {
	      var url = this._baseUrl;
	      if (!this.queryString.isEmpty()) {
	        url = url + '?' + this.queryString.urlencode();
	      }
	      return url;
	    }
	
	    /**
	     * Set/replace the query-string.
	     *
	     * @param {QueryString} queryStringObject The QueryString object
	     *      to replace the current query-string with.
	     *
	     * @example
	     * const urlparser = UrlParser('http://example.com/api/people');
	     * const querystring = new QueryString();
	     * querystring.set('search', 'doe');
	     * urlparser.setQueryString(querystring);
	     * // urlparser.buildUrl() === 'http://example.com/api/people?search=doe'
	     */
	
	  }, {
	    key: 'setQueryString',
	    value: function setQueryString(queryStringObject) {
	      this.queryString = queryStringObject;
	    }
	  }, {
	    key: 'scheme',
	    get: function get() {
	      return this._parsedBaseUrl.scheme;
	    }
	  }, {
	    key: 'path',
	    get: function get() {
	      return this._parsedBaseUrl.path;
	    }
	  }, {
	    key: 'domain',
	    get: function get() {
	      return this._parsedBaseUrl.domain;
	    }
	  }]);
	
	  return UrlParser;
	}();

/***/ }),

/***/ 17:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _loglevel = __webpack_require__(4);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 */
	var AbstractLogger = function () {
	  function AbstractLogger() {
	    _classCallCheck(this, AbstractLogger);
	  }
	
	  _createClass(AbstractLogger, [{
	    key: "getLogLevel",
	    value: function getLogLevel() {
	      throw new Error('Must be overridden in subclasses.');
	    }
	
	    /**
	     * Returns ``true`` if loglevel is higher
	     * than or equal to {@link LogLevels#DEBUG}.
	     */
	
	  }, {
	    key: "_noOutput",
	    value: function _noOutput() {}
	
	    /**
	     * Exposes console.log. Will only print if current level is
	     * higher than or equal to {@link LogLevels#DEBUG}.
	     * @returns {Function} console.log
	     */
	
	  }, {
	    key: "isDebug",
	    get: function get() {
	      return this.getLogLevel() >= _loglevel2.default.DEBUG;
	    }
	
	    /**
	     * Returns ``true`` if loglevel is higher
	     * than or equal to {@link LogLevels#INFO}.
	     */
	
	  }, {
	    key: "isInfo",
	    get: function get() {
	      return this.getLogLevel() >= _loglevel2.default.INFO;
	    }
	
	    /**
	     * Returns ``true`` if loglevel is higher
	     * than or equal to {@link LogLevels#WARNING}.
	     */
	
	  }, {
	    key: "isWarning",
	    get: function get() {
	      return this.getLogLevel() >= _loglevel2.default.WARNING;
	    }
	
	    /**
	     * Returns ``true`` if loglevel is higher
	     * than or equal to {@link LogLevels#ERROR}.
	     */
	
	  }, {
	    key: "isError",
	    get: function get() {
	      return this.getLogLevel() >= _loglevel2.default.ERROR;
	    }
	  }, {
	    key: "debug",
	    get: function get() {
	      if (this.getLogLevel() >= _loglevel2.default.DEBUG) {
	        return console.log.bind(console);
	      }
	      return this._noOutput;
	    }
	
	    /**
	     * Exposes console.log. Will only print if current level is
	     * higher than or equal to {@link LogLevels#INFO}.
	     * @returns {Function} console.log
	     */
	
	  }, {
	    key: "info",
	    get: function get() {
	      if (this.getLogLevel() >= _loglevel2.default.INFO) {
	        return console.log.bind(console);
	      }
	      return this._noOutput;
	    }
	
	    /**
	     * Exposes console.warn. Will only print if current level is
	     * higher than or equal to {@link LogLevels#WARNING}.
	     * @returns {Function} console.warn
	     */
	
	  }, {
	    key: "warning",
	    get: function get() {
	      if (this.getLogLevel() >= _loglevel2.default.WARNING) {
	        return console.warn.bind(console);
	      }
	      return this._noOutput;
	    }
	
	    /**
	     * Exposes console.error. Will only print if current level is
	     * higher than or equal to {@link LogLevels#ERROR}.
	     * @returns {Function} console.error
	     */
	
	  }, {
	    key: "error",
	    get: function get() {
	      if (this.getLogLevel() >= _loglevel2.default.ERROR) {
	        return console.error.bind(console);
	      }
	      return this._noOutput;
	    }
	  }]);
	
	  return AbstractLogger;
	}();
	
	exports.default = AbstractLogger;

/***/ }),

/***/ 18:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AbstractLogger2 = __webpack_require__(17);
	
	var _AbstractLogger3 = _interopRequireDefault(_AbstractLogger2);
	
	var _loglevel = __webpack_require__(4);
	
	var _loglevel2 = _interopRequireDefault(_loglevel);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Logger = function (_AbstractLogger) {
	    _inherits(Logger, _AbstractLogger);
	
	    /**
	     *
	     * @param {string} name The name of the logger.
	     * @param {LoggerSingleton} loggerSingleton The logger singleton
	     *      this logger belongs to.
	     */
	    function Logger(name, loggerSingleton) {
	        _classCallCheck(this, Logger);
	
	        var _this = _possibleConstructorReturn(this, (Logger.__proto__ || Object.getPrototypeOf(Logger)).call(this));
	
	        _this._name = name;
	        _this._logLevel = null;
	        _this._loggerSingleton = loggerSingleton;
	        return _this;
	    }
	
	    /**
	     * Get the name of this logger.
	     * @returns {string}
	     */
	
	
	    _createClass(Logger, [{
	        key: "setLogLevel",
	
	
	        /**
	         * Set the loglevel for this logger.
	         *
	         * @param {int} logLevel The log level. Must be one of the loglevels
	         *      defined in {@link LogLevels}.
	         * @throws {RangeError} if {@link LogLevels#validateLogLevel} fails.
	         */
	        value: function setLogLevel(logLevel) {
	            _loglevel2.default.validateLogLevel(logLevel);
	            this._logLevel = logLevel;
	        }
	
	        /**
	         * Get the log level.
	         *
	         * If no log level has been set with {@link Logger#setLogLevel},
	         * this returns {@link LoggerSingleton#getDefaultLogLevel}.
	         *
	         * @returns {int}
	         */
	
	    }, {
	        key: "getLogLevel",
	        value: function getLogLevel() {
	            if (this._logLevel == null) {
	                return this._loggerSingleton.getDefaultLogLevel();
	            }
	            return this._logLevel;
	        }
	
	        /**
	         * Get textual name for the log level. If the logger
	         * does not have a logLevel (if it inherits it from the LoggerSingleton)
	         * a string with information about this and the default logLevel for the
	         * LoggerSingleton is returned.
	         *
	         * Intended for debugging. The format of the string may change.
	         *
	         * @returns {string}
	         */
	
	    }, {
	        key: "getTextualNameForLogLevel",
	        value: function getTextualNameForLogLevel() {
	            if (this._logLevel == null) {
	                return '[default for LoggerSingleton - ' + (this._loggerSingleton.getTextualNameForDefaultLogLevel() + "]");
	            }
	            return _loglevel2.default.getTextualNameForLogLevel(this.getLogLevel());
	        }
	    }, {
	        key: "getDebugInfoString",
	        value: function getDebugInfoString() {
	            return this.name + ": " + this.getTextualNameForLogLevel();
	        }
	    }, {
	        key: "name",
	        get: function get() {
	            return this._name;
	        }
	    }]);
	
	    return Logger;
	}(_AbstractLogger3.default);
	
	exports.default = Logger;

/***/ }),

/***/ 19:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _typeDetect = __webpack_require__(6);
	
	var _typeDetect2 = _interopRequireDefault(_typeDetect);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	/**
	 * Utility-class with several static functions to simplify validation, merging and other standard operations on
	 * javascript-Objects.
	 */
	var ObjectManager = function () {
	    function ObjectManager() {
	        _classCallCheck(this, ObjectManager);
	    }
	
	    _createClass(ObjectManager, null, [{
	        key: "_hasOwnValue",
	
	        /**
	         * Checks that given object is not null and not undefined. Also checks the same inwards in provided nested keys
	         *
	         * @example
	         *  let check = this._hasOwnValue({"foo": {"bar": ""}}, false, true, "foo", "bar");
	         *  // check is now false. key "foo" is found, key "bar" is found, but "bar" is emptyString, and params specify to check for them
	         *
	         * @example
	         *  let check = this._hasOwnValue({"foo": {"bar": {}}}, true, false, "foo", "bar");
	         *  // check is now false. key "foo" is found, key "bar" is found, but "bar" is {}, and params specify to check for emptyObject.
	         *
	         * @example
	         *  let check = this._hasOwnValue({"foo": {"bar": {}}}, false, false, "foo", "bar");
	         *  // check is now true. key "foo" is found, key "bar" is found, so no requested values are null or undefined.
	         *
	         *  NOTE: Other functions in this file lets you ignore the boolean params - so just use them :)
	         *
	         * @param givenObject   The object to validate
	         * @param emptyObject   if true - keys mapped to empty object {} will also give false
	         * @param emptyString   if true - keys mapped to empty string "" will also give false
	         * @param args          nested keys to look for, so to validate myObject.foo.bar call this._hasOwnValue(myObject, false, false, "foo". "bar")
	         * @returns {boolean}   true if validation passes, false if not.
	         */
	        value: function _hasOwnValue(givenObject, emptyObject, emptyString) {
	            function checkValue(value) {
	                return value != undefined && value != null && (!emptyObject || value != {}) && (!emptyString || value != "");
	            }
	
	            if (!checkValue(givenObject)) {
	                return false;
	            }
	
	            for (var _len = arguments.length, args = Array(_len > 3 ? _len - 3 : 0), _key = 3; _key < _len; _key++) {
	                args[_key - 3] = arguments[_key];
	            }
	
	            var _iteratorNormalCompletion = true;
	            var _didIteratorError = false;
	            var _iteratorError = undefined;
	
	            try {
	                for (var _iterator = args[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true) {
	                    var key = _step.value;
	
	                    if (!(key in givenObject) || !checkValue(givenObject[key])) {
	                        return false;
	                    }
	                    givenObject = givenObject[key];
	                }
	            } catch (err) {
	                _didIteratorError = true;
	                _iteratorError = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion && _iterator.return) {
	                        _iterator.return();
	                    }
	                } finally {
	                    if (_didIteratorError) {
	                        throw _iteratorError;
	                    }
	                }
	            }
	
	            return true;
	        }
	
	        /**
	         * Validate that an object and nested keys are not null, undefined or empty string "".
	         *
	         * @example
	         * // check that myObject.foo.bar exists:
	         * validateAllowEmptyObject(myObject, "foo", "bar")
	         *
	         * @param givenObject   the object to validate
	         * @param args          nested keys to check
	         * @returns {boolean}   true if neither the object or any provided nested key is null, undefined or ""
	         */
	
	    }, {
	        key: "validateAllowEmptyObject",
	        value: function validateAllowEmptyObject(givenObject) {
	            for (var _len2 = arguments.length, args = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
	                args[_key2 - 1] = arguments[_key2];
	            }
	
	            return this._hasOwnValue.apply(this, [givenObject, false, true].concat(args));
	        }
	
	        /**
	         * Validate that an object and nested keys are not null, undefined or empty object {}.
	         *
	         * @example
	         * // check that myObject.foo.bar exists:
	         * validateAllowEmptyObject(myObject, "foo", "bar")
	         *
	         * @param givenObject   the object to validate
	         * @param args          nested keys to check
	         * @returns {boolean}   true if neither the object or any provided nested key is null, undefined or {}
	         */
	
	    }, {
	        key: "validateAllowEmptyString",
	        value: function validateAllowEmptyString(givenObject) {
	            for (var _len3 = arguments.length, args = Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++) {
	                args[_key3 - 1] = arguments[_key3];
	            }
	
	            return this._hasOwnValue.apply(this, [givenObject, true, false].concat(args));
	        }
	
	        /**
	         * Validate that an object and nested keys are not null, undefined or empty string "" or empty object {}.
	         *
	         * @example
	         * // check that myObject.foo.bar exists:
	         * validateAllowEmptyObject(myObject, "foo", "bar")
	         *
	         * @param givenObject   the object to validate
	         * @param args          nested keys to check
	         * @returns {boolean}   true if neither the object or any provided nested key is null, undefined, {} or ""
	         */
	
	    }, {
	        key: "validate",
	        value: function validate(givenObject) {
	            for (var _len4 = arguments.length, args = Array(_len4 > 1 ? _len4 - 1 : 0), _key4 = 1; _key4 < _len4; _key4++) {
	                args[_key4 - 1] = arguments[_key4];
	            }
	
	            return this._hasOwnValue.apply(this, [givenObject, true, true].concat(args));
	        }
	
	        /**
	         * Validate that an object and nested keys are not null or undefined.
	         *
	         * @example
	         * // check that myObject.foo.bar exists:
	         * validateAllowEmptyObject(myObject, "foo", "bar")
	         *
	         * @param givenObject   the object to validate
	         * @param args          nested keys to check
	         * @returns {boolean}   true if neither the object or any provided nested key is null or undefined.
	         */
	
	    }, {
	        key: "validateAllowEmptyStringAndEmptyObject",
	        value: function validateAllowEmptyStringAndEmptyObject(givenObject) {
	            for (var _len5 = arguments.length, args = Array(_len5 > 1 ? _len5 - 1 : 0), _key5 = 1; _key5 < _len5; _key5++) {
	                args[_key5 - 1] = arguments[_key5];
	            }
	
	            return this._hasOwnValue.apply(this, [givenObject, false, false].concat(args));
	        }
	
	        /**
	         * uses {@link validate} to lookup given args in given objectToBeValidated.
	         * This ensures the lookup is not null, undefined, empty object, or empty string.
	         * If this test fails, given fallbackValue is returned.
	         *
	         * @example
	         *  // to validate myObject.foo.bar, and get "helloworld" back as default if it is empty:
	         *  validateOrFallback("helloworld", myObject, "foo", "bar")
	         *
	         * @param fallbackValue         what to return if empty
	         * @param objectToBeValidated   object to do lookup in
	         * @param args                  indices used for lookup in object
	         * @returns {*}                 lookup in objectToBeValidated if validation succeeded, fallbackValue if not.
	         */
	
	    }, {
	        key: "validateOrFallback",
	        value: function validateOrFallback(fallbackValue, objectToBeValidated) {
	            for (var _len6 = arguments.length, args = Array(_len6 > 2 ? _len6 - 2 : 0), _key6 = 2; _key6 < _len6; _key6++) {
	                args[_key6 - 2] = arguments[_key6];
	            }
	
	            if (!this.validate.apply(this, [objectToBeValidated].concat(args))) {
	                return fallbackValue;
	            }
	            var _iteratorNormalCompletion2 = true;
	            var _didIteratorError2 = false;
	            var _iteratorError2 = undefined;
	
	            try {
	                for (var _iterator2 = args[Symbol.iterator](), _step2; !(_iteratorNormalCompletion2 = (_step2 = _iterator2.next()).done); _iteratorNormalCompletion2 = true) {
	                    var arg = _step2.value;
	
	                    objectToBeValidated = objectToBeValidated[arg];
	                }
	            } catch (err) {
	                _didIteratorError2 = true;
	                _iteratorError2 = err;
	            } finally {
	                try {
	                    if (!_iteratorNormalCompletion2 && _iterator2.return) {
	                        _iterator2.return();
	                    }
	                } finally {
	                    if (_didIteratorError2) {
	                        throw _iteratorError2;
	                    }
	                }
	            }
	
	            return objectToBeValidated;
	        }
	
	        /**
	         * Utilityfunction to simplify validation! uses {@link validateOrFallback} for validation, and executes
	         * given callback (and returns returnvalue from it) if validation fails.
	         *
	         * @param callback              Function to be executed if validation fails
	         * @param objectToBeValidated   The object to do validation-lookup in
	         * @param args                  indices used for lookup in objectToBeValidated
	         * @returns {*}                 lookup in objectToBeValidated if validation succeeded, returnvalue from callback if not.
	         */
	
	    }, {
	        key: "validateOrCallback",
	        value: function validateOrCallback(callback, objectToBeValidated) {
	            for (var _len7 = arguments.length, args = Array(_len7 > 2 ? _len7 - 2 : 0), _key7 = 2; _key7 < _len7; _key7++) {
	                args[_key7 - 2] = arguments[_key7];
	            }
	
	            var validatedValue = this.validateOrFallback.apply(this, [null, objectToBeValidated].concat(args));
	            if (validatedValue == null) {
	                return callback();
	            }
	            return validatedValue;
	        }
	
	        /**
	         * Utilityfunction to simplify validation! uses {@link validateOrCallback} for validation, and passes
	         * a callback that simply thrown an Error if validation fails.
	         *
	         * @param errorMessage          the message to use in new Error(errorMessage)
	         * @param objectToBeValidated   the object to validate args in
	         * @param args                  args for lookup. see {@link validateOrFallback}
	         * @returns {*}                 the looked-up value from objectToBeValidated if it exists
	         */
	
	    }, {
	        key: "validateOrError",
	        value: function validateOrError(errorMessage, objectToBeValidated) {
	            for (var _len8 = arguments.length, args = Array(_len8 > 2 ? _len8 - 2 : 0), _key8 = 2; _key8 < _len8; _key8++) {
	                args[_key8 - 2] = arguments[_key8];
	            }
	
	            return this.validateOrCallback.apply(this, [function () {
	                throw new Error(errorMessage);
	            }, objectToBeValidated].concat(args));
	        }
	    }, {
	        key: "_recursiveMerge",
	        value: function _recursiveMerge(mergedValues, overrides) {
	            for (var key in overrides) {
	                var detectedType = (0, _typeDetect2.default)(overrides[key]);
	                if (detectedType == 'object') {
	                    if (mergedValues[key] == undefined) {
	                        mergedValues[key] = {};
	                    }
	                    mergedValues[key] = this._recursiveMerge(mergedValues[key], overrides[key]);
	                } else if (detectedType == 'array') {
	                    mergedValues[key] = Array.from(overrides[key]);
	                } else if (detectedType == 'null' || detectedType == 'number' || detectedType == 'boolean' || detectedType == 'string') {
	                    mergedValues[key] = overrides[key];
	                } else {
	                    throw new Error("Unsupported type: " + detectedType + ".");
	                }
	            }
	            return mergedValues;
	        }
	
	        /**
	         * Deep copy all values from overrides to givenObject.
	         *
	         * All keys in passed overrides-object will be cloned to passed givenObject. This happens deeply, so all
	         * nested objects will also be iterated (NOTE: lists are not iterated, only objects).
	         *
	         * Note that objects are passed by-reference, so if you do not want givenObject to be modified directly make sure
	         * you pass false as third param
	         *
	         * @param givenObject             The object to override values in
	         * @param overrides               The object to copy all values from
	         * @param overrideValuesInGiven   if true givenObjects will be overwritten directly, if false a new object
	         *                                will be created to merge both given objects into.
	         * @returns {*}                   The result from deep-merging
	         */
	
	    }, {
	        key: "_merge",
	        value: function _merge(givenObject, overrides, overrideValuesInGiven) {
	            if (overrideValuesInGiven) {
	                return this._recursiveMerge(givenObject, overrides);
	            }
	
	            var mergedValues = {};
	            mergedValues = this._recursiveMerge(mergedValues, givenObject);
	            return this._recursiveMerge(mergedValues, overrides);
	        }
	
	        /**
	         * Merges all values from overrideObject into originalObject.
	         * This happens in place (as objects are passed-by-reference), so originalObject is modified.
	         *
	         * This is a deep-merge (unlike Object.assign).
	         *
	         * @example <caption>Simple example</caption>
	         * let originalObject = {
	         *      foo: "bar",
	         *      person: {
	         *          name: "Sandy claws",
	         *          age: 42
	         *      }
	         * }
	         *
	         * let overrideObject = {
	         *      foo: "baz",
	         *      person: {
	         *          age: 23,
	         *          phone: 12345678
	         *      }
	         *  }
	         *
	         *  ObjectManager.mergeInPlace(originalObject, overrideObject);
	         *
	         *  // originalObject will now be:
	         *  originalObject == {
	         *      foo: "baz",
	         *      person: {
	         *          age: 23,
	         *          phone: 12345678,
	         *          name: "Sandy claws"
	         *      }
	         *  }
	         *
	         * @param originalObject    the object to modify
	         * @param overrideObject    the object to copy values from
	         */
	
	    }, {
	        key: "mergeInPlace",
	        value: function mergeInPlace(originalObject, overrideObject) {
	            this._merge(originalObject, overrideObject, true);
	        }
	
	        /**
	         * Merges all values from originalObject and overrideObject into a new object that is returned.
	         *
	         * This is a deep-merge (unlike Object.assign).
	         *
	         * First, all values from originalObject are merged into a new object.
	         * Then all values from overrideObject are merged into the same object, overriding any corresponding keys from
	         * originalObject.
	         *
	         * @example <caption>Simple example</caption>
	         * let originalObject = {
	         *      foo: "bar",
	         *      person: {
	         *          name: "Sandy claws",
	         *          age: 42
	         *      }
	         * }
	         *
	         * let overrideObject = {
	         *      foo: "baz",
	         *      person: {
	         *          age: 23,
	         *          phone: 12345678
	         *      }
	         *  }
	         *
	         *  let mergedObject = ObjectManager.mergeAndCopy(originalObject, overrideObject);
	         *
	         *  // mergedObject will now be:
	         *  mergedObject == {
	         *      foo: "baz",
	         *      person: {
	         *          age: 23,
	         *          phone: 12345678,
	         *          name: "Sandy claws"
	         *      }
	         *  }
	         *
	         * @param originalObject    initial values for new object
	         * @param overrideObject    object to override values from original object with
	         * @returns {{}}            new object containing values from originalObject overridden by overrideObject (see example)
	         */
	
	    }, {
	        key: "mergeAndClone",
	        value: function mergeAndClone(originalObject, overrideObject) {
	            return this._merge(originalObject, overrideObject, false);
	        }
	
	        /**
	         * Copies all values from given originalObject into a new object, which is returned to caller.
	         *
	         * uses {@link ObjectManager#mergeAndClone}, but passes an empty object as one of the two it desires for merging..
	         *
	         * @param originalObject
	         * @returns {{}}
	         */
	
	    }, {
	        key: "clone",
	        value: function clone(originalObject) {
	            return this.mergeAndClone({}, originalObject);
	        }
	    }]);
	
	    return ObjectManager;
	}();
	
	exports.default = ObjectManager;

/***/ }),

/***/ 76:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _AbstractWidget2 = __webpack_require__(2);
	
	var _AbstractWidget3 = _interopRequireDefault(_AbstractWidget2);
	
	var _HttpDjangoJsonRequest = __webpack_require__(11);
	
	var _HttpDjangoJsonRequest2 = _interopRequireDefault(_HttpDjangoJsonRequest);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var selectSchoolWidget = function (_AbstractWidget) {
	  _inherits(selectSchoolWidget, _AbstractWidget);
	
	  function selectSchoolWidget(element, widgetInstanceId) {
	    _classCallCheck(this, selectSchoolWidget);
	
	    var _this = _possibleConstructorReturn(this, (selectSchoolWidget.__proto__ || Object.getPrototypeOf(selectSchoolWidget)).call(this, element, widgetInstanceId));
	
	    console.log(_this.element);
	    _this.setupBoundFunctions();
	    _this.element.addEventListener('input', _this.handleOnChangeEvent);
	    _this.inputTimeout = null;
	    _this.value = '';
	    _this.selectableElements = [];
	    _this.selectableListContainer = _this.makeSelectableListContainer();
	    _this.otherLink = _this.makeOtherLink();
	    _this.otherSelect = _this.makeOtherSelect();
	    _this.element.parentNode.appendChild(_this.selectableListContainer);
	    _this.element.parentNode.appendChild(_this.otherLink);
	    _this.statusElement = _this.makeStatusElement();
	    _this.loadInitialValue();
	    return _this;
	  }
	
	  _createClass(selectSchoolWidget, [{
	    key: 'loadInitialValue',
	    value: function loadInitialValue() {
	      var hiddenInput = this.element.parentNode.firstElementChild;
	      var hiddenValue = hiddenInput.value;
	      if (hiddenValue === '') {
	        return;
	      }
	      if (isNaN(hiddenValue)) {
	        this.renderOtherSelect();
	        this.otherSelect.value = hiddenValue;
	        hiddenInput.value = hiddenValue;
	      } else {
	        // TODO: call api and get name of id
	        this.requestInitialSchool(hiddenValue);
	      }
	    }
	  }, {
	    key: 'makeSelectableListContainer',
	    value: function makeSelectableListContainer() {
	      var element = document.createElement('div');
	      element.classList.add('search-select-list');
	      return element;
	    }
	  }, {
	    key: 'setupBoundFunctions',
	    value: function setupBoundFunctions() {
	      this.handleOnChangeEvent = this.handleOnChangeEvent.bind(this);
	      this.requestSchools = this.requestSchools.bind(this);
	      this.makeOption = this.makeOption.bind(this);
	    }
	  }, {
	    key: 'requestSchools',
	    value: function requestSchools() {
	      var _this2 = this;
	
	      window.clearTimeout(this.inputTimeout);
	      this.inputTimeout = null;
	      console.log('/api/school/?query=' + this.value);
	      new _HttpDjangoJsonRequest2.default('/api/school/?query=' + this.value).get().then(function (response) {
	        console.log(response.bodydata);
	        if (response.bodydata.count === 0) {
	          _this2.renderStatusIfNotAlreadyExists();
	          _this2.setStatus('Fant ingen skoler', 'error');
	        } else {
	          _this2.removeStatusIfExists();
	        }
	        response.bodydata.response.forEach(function (data) {
	          _this2.renderSelectableValue(data.name + ', ' + data.city, data.id);
	        });
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'requestInitialSchool',
	    value: function requestInitialSchool(id) {
	      var _this3 = this;
	
	      new _HttpDjangoJsonRequest2.default('/api/school/' + id).get().then(function (response) {
	        _this3.handleSelectSchool(id, response.bodydata.name + ', ' + response.bodydata.city);
	      }).catch(function (error) {
	        console.error(error);
	      });
	    }
	  }, {
	    key: 'clearHiddenValue',
	    value: function clearHiddenValue() {
	      this.element.previousElementSibling.value = '';
	    }
	  }, {
	    key: 'handleSelectSchool',
	    value: function handleSelectSchool(id, name) {
	      this.element.previousElementSibling.value = '' + id;
	      this.element.value = name;
	      console.log(this.element.previousSibling);
	      this.clearAllSelectableElements();
	    }
	  }, {
	    key: 'handleOtherOnChange',
	    value: function handleOtherOnChange(value) {
	      this.element.parentNode.firstElementChild.value = value;
	    }
	  }, {
	    key: 'handleOnChangeEvent',
	    value: function handleOnChangeEvent(event) {
	      this.value = event.target.value;
	      this.clearAllSelectableElements();
	      this.clearHiddenValue();
	      this.renderStatusIfNotAlreadyExists();
	      this.setStatus('Søker...');
	      if (!this.element.parentNode.contains(this.otherLink)) {
	        this.element.parentNode.appendChild(this.otherLink);
	      }
	
	      if (this.element.parentNode.contains(this.otherSelect)) {
	        this.element.parentNode.removeChild(this.otherSelect);
	      }
	
	      if (this.inputTimeout) {
	        window.clearTimeout(this.inputTimeout);
	        this.inputTimeout = null;
	      }
	      if (this.value !== '') {
	        this.inputTimeout = window.setTimeout(this.requestSchools, 1000);
	      } else {
	        this.removeStatusIfExists();
	      }
	    }
	  }, {
	    key: 'clearAllSelectableElements',
	    value: function clearAllSelectableElements() {
	      var _this4 = this;
	
	      this.selectableElements.forEach(function (element) {
	        _this4.selectableListContainer.removeChild(element);
	      });
	      this.selectableElements = [];
	    }
	  }, {
	    key: 'renderSelectableValue',
	    value: function renderSelectableValue(value, id) {
	      var _this5 = this;
	
	      var element = document.createElement('button');
	      element.innerText = value;
	      element.classList.add('search-select-list');
	      element.classList.add('search-select-list__item');
	      element.type = 'button';
	      element.addEventListener('click', function () {
	        _this5.handleSelectSchool(id, value);
	      });
	      this.selectableListContainer.appendChild(element);
	      this.selectableElements = [].concat(_toConsumableArray(this.selectableElements), [element]);
	    }
	  }, {
	    key: 'renderOtherSelect',
	    value: function renderOtherSelect() {
	      this.element.parentNode.removeChild(this.otherLink);
	      this.element.parentNode.appendChild(this.otherSelect);
	      this.clearAllSelectableElements();
	      this.clearHiddenValue();
	      this.removeStatusIfExists();
	      this.otherSelect.value = '';
	      this.element.value = '';
	    }
	  }, {
	    key: 'makeOtherLink',
	    value: function makeOtherLink() {
	      var _this6 = this;
	
	      var element = document.createElement('a');
	      element.innerText = 'Jeg er ikke tilknyttet skole/institusjon';
	      element.addEventListener('click', function (event) {
	        event.preventDefault();
	        _this6.renderOtherSelect();
	      });
	      return element;
	    }
	  }, {
	    key: 'makeOtherSelect',
	    value: function makeOtherSelect() {
	      var _this7 = this;
	
	      var element = document.createElement('select');
	      element.classList.add('form-control');
	      element.classList.add('c-square');
	      element.classList.add('c-theme');
	      element.classList.add('c-theme--outlined');
	      element.style.marginTop = '1rem';
	      element.style.display = 'block';
	      element.value = '';
	      this.otherOptionSpec.map(this.makeOption).forEach(function (option) {
	        element.appendChild(option);
	      });
	      element.addEventListener('change', function (event) {
	        _this7.handleOtherOnChange(event.target.value);
	      });
	      return element;
	    }
	  }, {
	    key: 'makeStatusElement',
	    value: function makeStatusElement() {
	      var element = document.createElement('span');
	      element.classList.add('message');
	      element.style.display = 'block';
	      element.innerText = '';
	      return element;
	    }
	  }, {
	    key: 'setStatus',
	    value: function setStatus(text) {
	      var variant = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	
	      if (this.statusElement.innerText === text) {
	        return;
	      }
	      this.statusElement.classList.remove('message--error');
	      this.statusElement.innerText = text;
	      if (variant !== '') {
	        this.statusElement.classList.add('message--' + variant);
	      }
	    }
	  }, {
	    key: 'renderStatusIfNotAlreadyExists',
	    value: function renderStatusIfNotAlreadyExists() {
	      if (!this.element.parentNode.contains(this.statusElement)) {
	        this.element.parentNode.insertBefore(this.statusElement, this.selectableListContainer);
	      }
	    }
	  }, {
	    key: 'removeStatusIfExists',
	    value: function removeStatusIfExists() {
	      if (this.element.parentNode.contains(this.statusElement)) {
	        this.element.parentNode.removeChild(this.statusElement);
	      }
	    }
	  }, {
	    key: 'makeOption',
	    value: function makeOption(_ref) {
	      var label = _ref.label,
	          value = _ref.value,
	          disabled = _ref.disabled,
	          defaultSelected = _ref.defaultSelected;
	
	      var element = document.createElement('option');
	      element.value = value;
	      element.innerText = label;
	      if (disabled) {
	        element.disabled = true;
	      }
	      if (defaultSelected) {
	        element.defaultSelected = true;
	      }
	      return element;
	    }
	  }, {
	    key: 'otherOptionSpec',
	    get: function get() {
	      return [{ label: 'Hva gjør du?', value: '', disabled: true, defaultSelected: true }, { label: 'Jeg leser selv', value: 'self-study', disabled: false, defaultSelected: false }, { label: 'Annet', value: 'other', disabled: false, defaultSelected: false }];
	    }
	  }]);
	
	  return selectSchoolWidget;
	}(_AbstractWidget3.default);
	
	exports.default = selectSchoolWidget;

/***/ })

/******/ });


// WEBPACK FOOTER //
// flipclass_publicui.js